unit View.Itens_Cupons.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewItens_CuponsEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbcupons_id: TLabel;
    edcupons_id: TDBEdit;
    lbproduto_id: TLabel;
    edproduto_id: TDBEdit;
    lbunidade_id: TLabel;
    edunidade_id: TDBEdit;
    lbitem: TLabel;
    editem: TDBEdit;
    lbcfop_cfop: TLabel;
    edcfop_cfop: TDBEdit;
    lbquantidade: TLabel;
    edquantidade: TDBEdit;
    lbproduto_preco: TLabel;
    edproduto_preco: TDBEdit;
    lbmargem_acrescimo: TLabel;
    edmargem_acrescimo: TDBEdit;
    lbvalor_acrescimo: TLabel;
    edvalor_acrescimo: TDBEdit;
    lbmargem_desconto: TLabel;
    edmargem_desconto: TDBEdit;
    lbvalor_desconto: TLabel;
    edvalor_desconto: TDBEdit;
    lbvalor_total: TLabel;
    edvalor_total: TDBEdit;
    lbaliquota_icms: TLabel;
    edaliquota_icms: TDBEdit;
    lbvalor_icms: TLabel;
    edvalor_icms: TDBEdit;
    lbaliquota_icms_red: TLabel;
    edaliquota_icms_red: TDBEdit;
    lbvalor_icms_red: TLabel;
    edvalor_icms_red: TDBEdit;
    lbvalor_base_calculo_icms: TLabel;
    edvalor_base_calculo_icms: TDBEdit;
    lbcst_id: TLabel;
    edcst_id: TDBEdit;
    lbvalor_base_calculo_pis: TLabel;
    edvalor_base_calculo_pis: TDBEdit;
    lbvalor_pis: TLabel;
    edvalor_pis: TDBEdit;
    lbvalor_base_calculo_cofins: TLabel;
    edvalor_base_calculo_cofins: TDBEdit;
    lbvalor_cofins: TLabel;
    edvalor_cofins: TDBEdit;
    lbcsosn_id: TLabel;
    edcsosn_id: TDBEdit;
    lbaliquota_pis: TLabel;
    edaliquota_pis: TDBEdit;
    lbaliquota_cofins: TLabel;
    edaliquota_cofins: TDBEdit;
    lbcst_pis_id: TLabel;
    edcst_pis_id: TDBEdit;
    lbcst_cofins_id: TLabel;
    edcst_cofins_id: TDBEdit;
    lbcodigo_natureza_pis_cofins_id: TLabel;
    edcodigo_natureza_pis_cofins_id: TDBEdit;
    lbaliquota_id: TLabel;
    edaliquota_id: TDBEdit;
    lbproduto_preco_custo: TLabel;
    edproduto_preco_custo: TDBEdit;
    lbcodigo_produto_movimenta_estoque: TLabel;
    edcodigo_produto_movimenta_estoque: TDBEdit;
    lbfuncionario_id: TLabel;
    edfuncionario_id: TDBEdit;
    lbitem_movimenta_estoque: TLabel;
    editem_movimenta_estoque: TDBEdit;
    lbquantidade_embalagem: TLabel;
    edquantidade_embalagem: TDBEdit;
    lbgrade_produto_id: TLabel;
    edgrade_produto_id: TDBEdit;
    lbproduto_nome: TLabel;
    edproduto_nome: TDBEdit;
    lbitem_quantidade_movimenta_estoque: TLabel;
    editem_quantidade_movimenta_estoque: TDBEdit;
    lbscan_promocoes_id: TLabel;
    edscan_promocoes_id: TDBEdit;
    lbvalor_desconto_scanntech: TLabel;
    edvalor_desconto_scanntech: TDBEdit;
    lbvalor_base_calculo_fcp_icms: TLabel;
    edvalor_base_calculo_fcp_icms: TDBEdit;
    lbaliquota_fcp_icms: TLabel;
    edaliquota_fcp_icms: TDBEdit;
    lbvalor_fcp_icms: TLabel;
    edvalor_fcp_icms: TDBEdit;
    lbvalor_base_calculo_fcp_retida: TLabel;
    edvalor_base_calculo_fcp_retida: TDBEdit;
    lbaliquota_fcp_retida: TLabel;
    edaliquota_fcp_retida: TDBEdit;
    lbvalor_fcp_retida: TLabel;
    edvalor_fcp_retida: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientItens_CuponsGet: TXDataWebClient;
    XDataClientItens_CuponsDelete: TXDataWebClient;
    Itens_CuponsDataset: TXDataWebDataSet;
    Itens_CuponsDatasetid: TIntegerField;
    Itens_CuponsDatasetaliado_id: TIntegerField;
    Itens_CuponsDatasetdata_base_id: TIntegerField;
    Itens_CuponsDatasetcupons_id: TIntegerField;
    Itens_CuponsDatasetproduto_id: TIntegerField;
    Itens_CuponsDatasetunidade_id: TIntegerField;
    Itens_CuponsDatasetitem: TIntegerField;
    Itens_CuponsDatasetcfop_cfop: TStringField;
    Itens_CuponsDatasetquantidade: TFloatField;
    Itens_CuponsDatasetproduto_preco: TFloatField;
    Itens_CuponsDatasetmargem_acrescimo: TFloatField;
    Itens_CuponsDatasetvalor_acrescimo: TFloatField;
    Itens_CuponsDatasetmargem_desconto: TFloatField;
    Itens_CuponsDatasetvalor_desconto: TFloatField;
    Itens_CuponsDatasetvalor_total: TFloatField;
    Itens_CuponsDatasetaliquota_icms: TFloatField;
    Itens_CuponsDatasetvalor_icms: TFloatField;
    Itens_CuponsDatasetaliquota_icms_red: TFloatField;
    Itens_CuponsDatasetvalor_icms_red: TFloatField;
    Itens_CuponsDatasetvalor_base_calculo_icms: TFloatField;
    Itens_CuponsDatasetcst_id: TStringField;
    Itens_CuponsDatasetvalor_base_calculo_pis: TFloatField;
    Itens_CuponsDatasetvalor_pis: TFloatField;
    Itens_CuponsDatasetvalor_base_calculo_cofins: TFloatField;
    Itens_CuponsDatasetvalor_cofins: TFloatField;
    Itens_CuponsDatasetcsosn_id: TStringField;
    Itens_CuponsDatasetaliquota_pis: TFloatField;
    Itens_CuponsDatasetaliquota_cofins: TFloatField;
    Itens_CuponsDatasetcst_pis_id: TStringField;
    Itens_CuponsDatasetcst_cofins_id: TStringField;
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id: TStringField;
    Itens_CuponsDatasetaliquota_id: TIntegerField;
    Itens_CuponsDatasetproduto_preco_custo: TFloatField;
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque: TIntegerField;
    Itens_CuponsDatasetfuncionario_id: TIntegerField;
    Itens_CuponsDatasetitem_movimenta_estoque: TBooleanField;
    Itens_CuponsDatasetquantidade_embalagem: TFloatField;
    Itens_CuponsDatasetgrade_produto_id: TIntegerField;
    Itens_CuponsDatasetproduto_nome: TStringField;
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque: TFloatField;
    Itens_CuponsDatasetscan_promocoes_id: TIntegerField;
    Itens_CuponsDatasetvalor_desconto_scanntech: TFloatField;
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms: TFloatField;
    Itens_CuponsDatasetaliquota_fcp_icms: TFloatField;
    Itens_CuponsDatasetvalor_fcp_icms: TFloatField;
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida: TFloatField;
    Itens_CuponsDatasetaliquota_fcp_retida: TFloatField;
    Itens_CuponsDatasetvalor_fcp_retida: TFloatField;
    Itens_CuponsDatasetcodigo_interno: TIntegerField;
    Itens_CuponsDatasetexcluido: TBooleanField;
    Itens_CuponsDatasetinclusao: TDateTimeField;
    Itens_CuponsDatasetalteracao: TDateTimeField;
    Itens_CuponsDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientItens_CuponsGetLoad(Response: TXDataClientResponse);
    procedure XDataClientItens_CuponsDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientItens_CuponsDeleteError(Error: TXDataClientError);
    procedure Itens_CuponsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewItens_CuponsEdit: TFViewItens_CuponsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewItens_CuponsEdit }

procedure TFViewItens_CuponsEdit.btSaveClick(Sender: TObject);
begin
  if Itens_CuponsDataset.State in dsEditModes then
  begin
        Itens_CuponsDataset.Post;
    Itens_CuponsDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewItens_CuponsEdit.btDeleteClick(Sender: TObject);
begin
  if Itens_CuponsDataset.State in dsEditModes then
    Itens_CuponsDataset.Post;
  XDataClientItens_CuponsDelete.Delete(Itens_CuponsDataset.EntitySetName,
    TJSObject(Itens_CuponsDataset.CurrentData));
end;


class function TFViewItens_CuponsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewItens_CuponsEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewItens_CuponsEdit.InsertEntity;
begin
  Itens_CuponsDataset.Close;
  Itens_CuponsDataset.SetJsonData('{}');
  Itens_CuponsDataset.Open;
  Itens_CuponsDataset.Insert;
end;

class function TFViewItens_CuponsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewItens_CuponsEdit(AForm).FInserting := AInserting;
    TFViewItens_CuponsEdit(AForm).FId := AId;
    TFViewItens_CuponsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewItens_CuponsEdit(AForm).InsertEntity
    else
      TFViewItens_CuponsEdit(AForm).LoadEntity;
    TFViewItens_CuponsEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewItens_CuponsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewItens_CuponsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Itens_CuponsDataset.Connection.Model.DefaultSchema.FindEntityType(
      Itens_CuponsDataset.EntitySetName
    )
  );
  XDataClientItens_CuponsGet.Get(Itens_CuponsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewItens_CuponsEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewItens_CuponsEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewItens_CuponsEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewItens_CuponsEdit.XDataClientItens_CuponsGetLoad(Response: TXDataClientResponse);
begin
  Itens_CuponsDataset.Close;
  Itens_CuponsDataset.SetJsonData(Response.Result);
  Itens_CuponsDataset.Open;
  
  Itens_CuponsDataset.Edit;  
end;

procedure TFViewItens_CuponsEdit.XDataClientItens_CuponsDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewItens_CuponsEdit.XDataClientItens_CuponsDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewItens_CuponsEdit.Itens_CuponsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewItens_CuponsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewItens_CuponsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.itens_cupons.form.message');
  lbMessage := TLabel.Create('view.itens_cupons.form.message.label');
  btCloseMessage := TButton.Create('view.itens_cupons.form.message.button');
  btCancel := TButton.Create('view.itens_cupons.form.btBack');
  btSave := TButton.Create('view.itens_cupons.form.btSave');
  btDelete := TButton.Create('view.itens_cupons.form.btDelete');
  lbid := TLabel.Create('view.itens_cupons.form.lbid');
  edid := TDBEdit.Create('view.itens_cupons.form.edid');
  lbaliado_id := TLabel.Create('view.itens_cupons.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.itens_cupons.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.itens_cupons.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.itens_cupons.form.eddata_base_id');
  lbcupons_id := TLabel.Create('view.itens_cupons.form.lbcupons_id');
  edcupons_id := TDBEdit.Create('view.itens_cupons.form.edcupons_id');
  lbproduto_id := TLabel.Create('view.itens_cupons.form.lbproduto_id');
  edproduto_id := TDBEdit.Create('view.itens_cupons.form.edproduto_id');
  lbunidade_id := TLabel.Create('view.itens_cupons.form.lbunidade_id');
  edunidade_id := TDBEdit.Create('view.itens_cupons.form.edunidade_id');
  lbitem := TLabel.Create('view.itens_cupons.form.lbitem');
  editem := TDBEdit.Create('view.itens_cupons.form.editem');
  lbcfop_cfop := TLabel.Create('view.itens_cupons.form.lbcfop_cfop');
  edcfop_cfop := TDBEdit.Create('view.itens_cupons.form.edcfop_cfop');
  lbquantidade := TLabel.Create('view.itens_cupons.form.lbquantidade');
  edquantidade := TDBEdit.Create('view.itens_cupons.form.edquantidade');
  lbproduto_preco := TLabel.Create('view.itens_cupons.form.lbproduto_preco');
  edproduto_preco := TDBEdit.Create('view.itens_cupons.form.edproduto_preco');
  lbmargem_acrescimo := TLabel.Create('view.itens_cupons.form.lbmargem_acrescimo');
  edmargem_acrescimo := TDBEdit.Create('view.itens_cupons.form.edmargem_acrescimo');
  lbvalor_acrescimo := TLabel.Create('view.itens_cupons.form.lbvalor_acrescimo');
  edvalor_acrescimo := TDBEdit.Create('view.itens_cupons.form.edvalor_acrescimo');
  lbmargem_desconto := TLabel.Create('view.itens_cupons.form.lbmargem_desconto');
  edmargem_desconto := TDBEdit.Create('view.itens_cupons.form.edmargem_desconto');
  lbvalor_desconto := TLabel.Create('view.itens_cupons.form.lbvalor_desconto');
  edvalor_desconto := TDBEdit.Create('view.itens_cupons.form.edvalor_desconto');
  lbvalor_total := TLabel.Create('view.itens_cupons.form.lbvalor_total');
  edvalor_total := TDBEdit.Create('view.itens_cupons.form.edvalor_total');
  lbaliquota_icms := TLabel.Create('view.itens_cupons.form.lbaliquota_icms');
  edaliquota_icms := TDBEdit.Create('view.itens_cupons.form.edaliquota_icms');
  lbvalor_icms := TLabel.Create('view.itens_cupons.form.lbvalor_icms');
  edvalor_icms := TDBEdit.Create('view.itens_cupons.form.edvalor_icms');
  lbaliquota_icms_red := TLabel.Create('view.itens_cupons.form.lbaliquota_icms_red');
  edaliquota_icms_red := TDBEdit.Create('view.itens_cupons.form.edaliquota_icms_red');
  lbvalor_icms_red := TLabel.Create('view.itens_cupons.form.lbvalor_icms_red');
  edvalor_icms_red := TDBEdit.Create('view.itens_cupons.form.edvalor_icms_red');
  lbvalor_base_calculo_icms := TLabel.Create('view.itens_cupons.form.lbvalor_base_calculo_icms');
  edvalor_base_calculo_icms := TDBEdit.Create('view.itens_cupons.form.edvalor_base_calculo_icms');
  lbcst_id := TLabel.Create('view.itens_cupons.form.lbcst_id');
  edcst_id := TDBEdit.Create('view.itens_cupons.form.edcst_id');
  lbvalor_base_calculo_pis := TLabel.Create('view.itens_cupons.form.lbvalor_base_calculo_pis');
  edvalor_base_calculo_pis := TDBEdit.Create('view.itens_cupons.form.edvalor_base_calculo_pis');
  lbvalor_pis := TLabel.Create('view.itens_cupons.form.lbvalor_pis');
  edvalor_pis := TDBEdit.Create('view.itens_cupons.form.edvalor_pis');
  lbvalor_base_calculo_cofins := TLabel.Create('view.itens_cupons.form.lbvalor_base_calculo_cofins');
  edvalor_base_calculo_cofins := TDBEdit.Create('view.itens_cupons.form.edvalor_base_calculo_cofins');
  lbvalor_cofins := TLabel.Create('view.itens_cupons.form.lbvalor_cofins');
  edvalor_cofins := TDBEdit.Create('view.itens_cupons.form.edvalor_cofins');
  lbcsosn_id := TLabel.Create('view.itens_cupons.form.lbcsosn_id');
  edcsosn_id := TDBEdit.Create('view.itens_cupons.form.edcsosn_id');
  lbaliquota_pis := TLabel.Create('view.itens_cupons.form.lbaliquota_pis');
  edaliquota_pis := TDBEdit.Create('view.itens_cupons.form.edaliquota_pis');
  lbaliquota_cofins := TLabel.Create('view.itens_cupons.form.lbaliquota_cofins');
  edaliquota_cofins := TDBEdit.Create('view.itens_cupons.form.edaliquota_cofins');
  lbcst_pis_id := TLabel.Create('view.itens_cupons.form.lbcst_pis_id');
  edcst_pis_id := TDBEdit.Create('view.itens_cupons.form.edcst_pis_id');
  lbcst_cofins_id := TLabel.Create('view.itens_cupons.form.lbcst_cofins_id');
  edcst_cofins_id := TDBEdit.Create('view.itens_cupons.form.edcst_cofins_id');
  lbcodigo_natureza_pis_cofins_id := TLabel.Create('view.itens_cupons.form.lbcodigo_natureza_pis_cofins_id');
  edcodigo_natureza_pis_cofins_id := TDBEdit.Create('view.itens_cupons.form.edcodigo_natureza_pis_cofins_id');
  lbaliquota_id := TLabel.Create('view.itens_cupons.form.lbaliquota_id');
  edaliquota_id := TDBEdit.Create('view.itens_cupons.form.edaliquota_id');
  lbproduto_preco_custo := TLabel.Create('view.itens_cupons.form.lbproduto_preco_custo');
  edproduto_preco_custo := TDBEdit.Create('view.itens_cupons.form.edproduto_preco_custo');
  lbcodigo_produto_movimenta_estoque := TLabel.Create('view.itens_cupons.form.lbcodigo_produto_movimenta_estoque');
  edcodigo_produto_movimenta_estoque := TDBEdit.Create('view.itens_cupons.form.edcodigo_produto_movimenta_estoque');
  lbfuncionario_id := TLabel.Create('view.itens_cupons.form.lbfuncionario_id');
  edfuncionario_id := TDBEdit.Create('view.itens_cupons.form.edfuncionario_id');
  lbitem_movimenta_estoque := TLabel.Create('view.itens_cupons.form.lbitem_movimenta_estoque');
  editem_movimenta_estoque := TDBEdit.Create('view.itens_cupons.form.editem_movimenta_estoque');
  lbquantidade_embalagem := TLabel.Create('view.itens_cupons.form.lbquantidade_embalagem');
  edquantidade_embalagem := TDBEdit.Create('view.itens_cupons.form.edquantidade_embalagem');
  lbgrade_produto_id := TLabel.Create('view.itens_cupons.form.lbgrade_produto_id');
  edgrade_produto_id := TDBEdit.Create('view.itens_cupons.form.edgrade_produto_id');
  lbproduto_nome := TLabel.Create('view.itens_cupons.form.lbproduto_nome');
  edproduto_nome := TDBEdit.Create('view.itens_cupons.form.edproduto_nome');
  lbitem_quantidade_movimenta_estoque := TLabel.Create('view.itens_cupons.form.lbitem_quantidade_movimenta_estoque');
  editem_quantidade_movimenta_estoque := TDBEdit.Create('view.itens_cupons.form.editem_quantidade_movimenta_estoque');
  lbscan_promocoes_id := TLabel.Create('view.itens_cupons.form.lbscan_promocoes_id');
  edscan_promocoes_id := TDBEdit.Create('view.itens_cupons.form.edscan_promocoes_id');
  lbvalor_desconto_scanntech := TLabel.Create('view.itens_cupons.form.lbvalor_desconto_scanntech');
  edvalor_desconto_scanntech := TDBEdit.Create('view.itens_cupons.form.edvalor_desconto_scanntech');
  lbvalor_base_calculo_fcp_icms := TLabel.Create('view.itens_cupons.form.lbvalor_base_calculo_fcp_icms');
  edvalor_base_calculo_fcp_icms := TDBEdit.Create('view.itens_cupons.form.edvalor_base_calculo_fcp_icms');
  lbaliquota_fcp_icms := TLabel.Create('view.itens_cupons.form.lbaliquota_fcp_icms');
  edaliquota_fcp_icms := TDBEdit.Create('view.itens_cupons.form.edaliquota_fcp_icms');
  lbvalor_fcp_icms := TLabel.Create('view.itens_cupons.form.lbvalor_fcp_icms');
  edvalor_fcp_icms := TDBEdit.Create('view.itens_cupons.form.edvalor_fcp_icms');
  lbvalor_base_calculo_fcp_retida := TLabel.Create('view.itens_cupons.form.lbvalor_base_calculo_fcp_retida');
  edvalor_base_calculo_fcp_retida := TDBEdit.Create('view.itens_cupons.form.edvalor_base_calculo_fcp_retida');
  lbaliquota_fcp_retida := TLabel.Create('view.itens_cupons.form.lbaliquota_fcp_retida');
  edaliquota_fcp_retida := TDBEdit.Create('view.itens_cupons.form.edaliquota_fcp_retida');
  lbvalor_fcp_retida := TLabel.Create('view.itens_cupons.form.lbvalor_fcp_retida');
  edvalor_fcp_retida := TDBEdit.Create('view.itens_cupons.form.edvalor_fcp_retida');
  lbcodigo_interno := TLabel.Create('view.itens_cupons.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.itens_cupons.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.itens_cupons.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.itens_cupons.form.edexcluido');
  lbinclusao := TLabel.Create('view.itens_cupons.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.itens_cupons.form.edinclusao');
  lbalteracao := TLabel.Create('view.itens_cupons.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.itens_cupons.form.edalteracao');
  lbexclusao := TLabel.Create('view.itens_cupons.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.itens_cupons.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Itens_CuponsDataset := TXDataWebDataSet.Create(Self);
  Itens_CuponsDatasetid := TIntegerField.Create(Self);
  Itens_CuponsDatasetaliado_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetdata_base_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetcupons_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetproduto_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetunidade_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetitem := TIntegerField.Create(Self);
  Itens_CuponsDatasetcfop_cfop := TStringField.Create(Self);
  Itens_CuponsDatasetquantidade := TFloatField.Create(Self);
  Itens_CuponsDatasetproduto_preco := TFloatField.Create(Self);
  Itens_CuponsDatasetmargem_acrescimo := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_acrescimo := TFloatField.Create(Self);
  Itens_CuponsDatasetmargem_desconto := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_desconto := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_total := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_icms_red := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_icms_red := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetcst_id := TStringField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_pis := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_pis := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_cofins := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_cofins := TFloatField.Create(Self);
  Itens_CuponsDatasetcsosn_id := TStringField.Create(Self);
  Itens_CuponsDatasetaliquota_pis := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_cofins := TFloatField.Create(Self);
  Itens_CuponsDatasetcst_pis_id := TStringField.Create(Self);
  Itens_CuponsDatasetcst_cofins_id := TStringField.Create(Self);
  Itens_CuponsDatasetcodigo_natureza_pis_cofins_id := TStringField.Create(Self);
  Itens_CuponsDatasetaliquota_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetproduto_preco_custo := TFloatField.Create(Self);
  Itens_CuponsDatasetcodigo_produto_movimenta_estoque := TIntegerField.Create(Self);
  Itens_CuponsDatasetfuncionario_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetitem_movimenta_estoque := TBooleanField.Create(Self);
  Itens_CuponsDatasetquantidade_embalagem := TFloatField.Create(Self);
  Itens_CuponsDatasetgrade_produto_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetproduto_nome := TStringField.Create(Self);
  Itens_CuponsDatasetitem_quantidade_movimenta_estoque := TFloatField.Create(Self);
  Itens_CuponsDatasetscan_promocoes_id := TIntegerField.Create(Self);
  Itens_CuponsDatasetvalor_desconto_scanntech := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_fcp_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_fcp_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_fcp_icms := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_base_calculo_fcp_retida := TFloatField.Create(Self);
  Itens_CuponsDatasetaliquota_fcp_retida := TFloatField.Create(Self);
  Itens_CuponsDatasetvalor_fcp_retida := TFloatField.Create(Self);
  Itens_CuponsDatasetcodigo_interno := TIntegerField.Create(Self);
  Itens_CuponsDatasetexcluido := TBooleanField.Create(Self);
  Itens_CuponsDatasetinclusao := TDateTimeField.Create(Self);
  Itens_CuponsDatasetalteracao := TDateTimeField.Create(Self);
  Itens_CuponsDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientItens_CuponsGet := TXDataWebClient.Create(Self);
  XDataClientItens_CuponsDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbcupons_id.BeforeLoadDFMValues;
  edcupons_id.BeforeLoadDFMValues;
  lbproduto_id.BeforeLoadDFMValues;
  edproduto_id.BeforeLoadDFMValues;
  lbunidade_id.BeforeLoadDFMValues;
  edunidade_id.BeforeLoadDFMValues;
  lbitem.BeforeLoadDFMValues;
  editem.BeforeLoadDFMValues;
  lbcfop_cfop.BeforeLoadDFMValues;
  edcfop_cfop.BeforeLoadDFMValues;
  lbquantidade.BeforeLoadDFMValues;
  edquantidade.BeforeLoadDFMValues;
  lbproduto_preco.BeforeLoadDFMValues;
  edproduto_preco.BeforeLoadDFMValues;
  lbmargem_acrescimo.BeforeLoadDFMValues;
  edmargem_acrescimo.BeforeLoadDFMValues;
  lbvalor_acrescimo.BeforeLoadDFMValues;
  edvalor_acrescimo.BeforeLoadDFMValues;
  lbmargem_desconto.BeforeLoadDFMValues;
  edmargem_desconto.BeforeLoadDFMValues;
  lbvalor_desconto.BeforeLoadDFMValues;
  edvalor_desconto.BeforeLoadDFMValues;
  lbvalor_total.BeforeLoadDFMValues;
  edvalor_total.BeforeLoadDFMValues;
  lbaliquota_icms.BeforeLoadDFMValues;
  edaliquota_icms.BeforeLoadDFMValues;
  lbvalor_icms.BeforeLoadDFMValues;
  edvalor_icms.BeforeLoadDFMValues;
  lbaliquota_icms_red.BeforeLoadDFMValues;
  edaliquota_icms_red.BeforeLoadDFMValues;
  lbvalor_icms_red.BeforeLoadDFMValues;
  edvalor_icms_red.BeforeLoadDFMValues;
  lbvalor_base_calculo_icms.BeforeLoadDFMValues;
  edvalor_base_calculo_icms.BeforeLoadDFMValues;
  lbcst_id.BeforeLoadDFMValues;
  edcst_id.BeforeLoadDFMValues;
  lbvalor_base_calculo_pis.BeforeLoadDFMValues;
  edvalor_base_calculo_pis.BeforeLoadDFMValues;
  lbvalor_pis.BeforeLoadDFMValues;
  edvalor_pis.BeforeLoadDFMValues;
  lbvalor_base_calculo_cofins.BeforeLoadDFMValues;
  edvalor_base_calculo_cofins.BeforeLoadDFMValues;
  lbvalor_cofins.BeforeLoadDFMValues;
  edvalor_cofins.BeforeLoadDFMValues;
  lbcsosn_id.BeforeLoadDFMValues;
  edcsosn_id.BeforeLoadDFMValues;
  lbaliquota_pis.BeforeLoadDFMValues;
  edaliquota_pis.BeforeLoadDFMValues;
  lbaliquota_cofins.BeforeLoadDFMValues;
  edaliquota_cofins.BeforeLoadDFMValues;
  lbcst_pis_id.BeforeLoadDFMValues;
  edcst_pis_id.BeforeLoadDFMValues;
  lbcst_cofins_id.BeforeLoadDFMValues;
  edcst_cofins_id.BeforeLoadDFMValues;
  lbcodigo_natureza_pis_cofins_id.BeforeLoadDFMValues;
  edcodigo_natureza_pis_cofins_id.BeforeLoadDFMValues;
  lbaliquota_id.BeforeLoadDFMValues;
  edaliquota_id.BeforeLoadDFMValues;
  lbproduto_preco_custo.BeforeLoadDFMValues;
  edproduto_preco_custo.BeforeLoadDFMValues;
  lbcodigo_produto_movimenta_estoque.BeforeLoadDFMValues;
  edcodigo_produto_movimenta_estoque.BeforeLoadDFMValues;
  lbfuncionario_id.BeforeLoadDFMValues;
  edfuncionario_id.BeforeLoadDFMValues;
  lbitem_movimenta_estoque.BeforeLoadDFMValues;
  editem_movimenta_estoque.BeforeLoadDFMValues;
  lbquantidade_embalagem.BeforeLoadDFMValues;
  edquantidade_embalagem.BeforeLoadDFMValues;
  lbgrade_produto_id.BeforeLoadDFMValues;
  edgrade_produto_id.BeforeLoadDFMValues;
  lbproduto_nome.BeforeLoadDFMValues;
  edproduto_nome.BeforeLoadDFMValues;
  lbitem_quantidade_movimenta_estoque.BeforeLoadDFMValues;
  editem_quantidade_movimenta_estoque.BeforeLoadDFMValues;
  lbscan_promocoes_id.BeforeLoadDFMValues;
  edscan_promocoes_id.BeforeLoadDFMValues;
  lbvalor_desconto_scanntech.BeforeLoadDFMValues;
  edvalor_desconto_scanntech.BeforeLoadDFMValues;
  lbvalor_base_calculo_fcp_icms.BeforeLoadDFMValues;
  edvalor_base_calculo_fcp_icms.BeforeLoadDFMValues;
  lbaliquota_fcp_icms.BeforeLoadDFMValues;
  edaliquota_fcp_icms.BeforeLoadDFMValues;
  lbvalor_fcp_icms.BeforeLoadDFMValues;
  edvalor_fcp_icms.BeforeLoadDFMValues;
  lbvalor_base_calculo_fcp_retida.BeforeLoadDFMValues;
  edvalor_base_calculo_fcp_retida.BeforeLoadDFMValues;
  lbaliquota_fcp_retida.BeforeLoadDFMValues;
  edaliquota_fcp_retida.BeforeLoadDFMValues;
  lbvalor_fcp_retida.BeforeLoadDFMValues;
  edvalor_fcp_retida.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Itens_CuponsDataset.BeforeLoadDFMValues;
  Itens_CuponsDatasetid.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliado_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetdata_base_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetcupons_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetproduto_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetunidade_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetitem.BeforeLoadDFMValues;
  Itens_CuponsDatasetcfop_cfop.BeforeLoadDFMValues;
  Itens_CuponsDatasetquantidade.BeforeLoadDFMValues;
  Itens_CuponsDatasetproduto_preco.BeforeLoadDFMValues;
  Itens_CuponsDatasetmargem_acrescimo.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_acrescimo.BeforeLoadDFMValues;
  Itens_CuponsDatasetmargem_desconto.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_desconto.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_total.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_icms_red.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_icms_red.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetcst_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_pis.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_pis.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_cofins.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_cofins.BeforeLoadDFMValues;
  Itens_CuponsDatasetcsosn_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_pis.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_cofins.BeforeLoadDFMValues;
  Itens_CuponsDatasetcst_pis_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetcst_cofins_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetproduto_preco_custo.BeforeLoadDFMValues;
  Itens_CuponsDatasetcodigo_produto_movimenta_estoque.BeforeLoadDFMValues;
  Itens_CuponsDatasetfuncionario_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetitem_movimenta_estoque.BeforeLoadDFMValues;
  Itens_CuponsDatasetquantidade_embalagem.BeforeLoadDFMValues;
  Itens_CuponsDatasetgrade_produto_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetproduto_nome.BeforeLoadDFMValues;
  Itens_CuponsDatasetitem_quantidade_movimenta_estoque.BeforeLoadDFMValues;
  Itens_CuponsDatasetscan_promocoes_id.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_desconto_scanntech.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_fcp_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_fcp_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_fcp_icms.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_base_calculo_fcp_retida.BeforeLoadDFMValues;
  Itens_CuponsDatasetaliquota_fcp_retida.BeforeLoadDFMValues;
  Itens_CuponsDatasetvalor_fcp_retida.BeforeLoadDFMValues;
  Itens_CuponsDatasetcodigo_interno.BeforeLoadDFMValues;
  Itens_CuponsDatasetexcluido.BeforeLoadDFMValues;
  Itens_CuponsDatasetinclusao.BeforeLoadDFMValues;
  Itens_CuponsDatasetalteracao.BeforeLoadDFMValues;
  Itens_CuponsDatasetexclusao.BeforeLoadDFMValues;
  XDataClientItens_CuponsGet.BeforeLoadDFMValues;
  XDataClientItens_CuponsDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewItens_CuponsEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 1696;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 1636;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 1636;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 1636;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbcupons_id.SetParentComponent(Self);
    lbcupons_id.Name := 'lbcupons_id';
    lbcupons_id.Left := 24;
    lbcupons_id.Top := 273;
    lbcupons_id.Width := 14;
    lbcupons_id.Height := 13;
    lbcupons_id.Caption := 'cupons_id:';
    lbcupons_id.Transparent := True;
    edcupons_id.SetParentComponent(Self);
    edcupons_id.Name := 'edcupons_id';
    edcupons_id.Left := 221;
    edcupons_id.Top := 270;
    edcupons_id.Width := 200;
    edcupons_id.Height := 21;
    edcupons_id.Enabled := True;
    edcupons_id.TabOrder := 9;
    edcupons_id.Text := 'edcupons_id';
    edcupons_id.DataField := 'cupons_id';
    edcupons_id.DataSource := DataSource;
    lbproduto_id.SetParentComponent(Self);
    lbproduto_id.Name := 'lbproduto_id';
    lbproduto_id.Left := 24;
    lbproduto_id.Top := 300;
    lbproduto_id.Width := 14;
    lbproduto_id.Height := 13;
    lbproduto_id.Caption := 'produto_id:';
    lbproduto_id.Transparent := True;
    edproduto_id.SetParentComponent(Self);
    edproduto_id.Name := 'edproduto_id';
    edproduto_id.Left := 221;
    edproduto_id.Top := 297;
    edproduto_id.Width := 200;
    edproduto_id.Height := 21;
    edproduto_id.Enabled := True;
    edproduto_id.TabOrder := 10;
    edproduto_id.Text := 'edproduto_id';
    edproduto_id.DataField := 'produto_id';
    edproduto_id.DataSource := DataSource;
    lbunidade_id.SetParentComponent(Self);
    lbunidade_id.Name := 'lbunidade_id';
    lbunidade_id.Left := 24;
    lbunidade_id.Top := 327;
    lbunidade_id.Width := 14;
    lbunidade_id.Height := 13;
    lbunidade_id.Caption := 'unidade_id:';
    lbunidade_id.Transparent := True;
    edunidade_id.SetParentComponent(Self);
    edunidade_id.Name := 'edunidade_id';
    edunidade_id.Left := 221;
    edunidade_id.Top := 324;
    edunidade_id.Width := 200;
    edunidade_id.Height := 21;
    edunidade_id.Enabled := True;
    edunidade_id.TabOrder := 11;
    edunidade_id.Text := 'edunidade_id';
    edunidade_id.DataField := 'unidade_id';
    edunidade_id.DataSource := DataSource;
    lbitem.SetParentComponent(Self);
    lbitem.Name := 'lbitem';
    lbitem.Left := 24;
    lbitem.Top := 354;
    lbitem.Width := 14;
    lbitem.Height := 13;
    lbitem.Caption := 'item:';
    lbitem.Transparent := True;
    editem.SetParentComponent(Self);
    editem.Name := 'editem';
    editem.Left := 221;
    editem.Top := 351;
    editem.Width := 200;
    editem.Height := 21;
    editem.Enabled := True;
    editem.TabOrder := 12;
    editem.Text := 'editem';
    editem.DataField := 'item';
    editem.DataSource := DataSource;
    lbcfop_cfop.SetParentComponent(Self);
    lbcfop_cfop.Name := 'lbcfop_cfop';
    lbcfop_cfop.Left := 24;
    lbcfop_cfop.Top := 381;
    lbcfop_cfop.Width := 14;
    lbcfop_cfop.Height := 13;
    lbcfop_cfop.Caption := 'cfop_cfop:';
    lbcfop_cfop.Transparent := True;
    edcfop_cfop.SetParentComponent(Self);
    edcfop_cfop.Name := 'edcfop_cfop';
    edcfop_cfop.Left := 221;
    edcfop_cfop.Top := 378;
    edcfop_cfop.Width := 200;
    edcfop_cfop.Height := 21;
    edcfop_cfop.Enabled := True;
    edcfop_cfop.TabOrder := 13;
    edcfop_cfop.Text := 'edcfop_cfop';
    edcfop_cfop.DataField := 'cfop_cfop';
    edcfop_cfop.DataSource := DataSource;
    lbquantidade.SetParentComponent(Self);
    lbquantidade.Name := 'lbquantidade';
    lbquantidade.Left := 24;
    lbquantidade.Top := 408;
    lbquantidade.Width := 14;
    lbquantidade.Height := 13;
    lbquantidade.Caption := 'quantidade:';
    lbquantidade.Transparent := True;
    edquantidade.SetParentComponent(Self);
    edquantidade.Name := 'edquantidade';
    edquantidade.Left := 221;
    edquantidade.Top := 405;
    edquantidade.Width := 200;
    edquantidade.Height := 21;
    edquantidade.Enabled := True;
    edquantidade.TabOrder := 14;
    edquantidade.Text := 'edquantidade';
    edquantidade.DataField := 'quantidade';
    edquantidade.DataSource := DataSource;
    lbproduto_preco.SetParentComponent(Self);
    lbproduto_preco.Name := 'lbproduto_preco';
    lbproduto_preco.Left := 24;
    lbproduto_preco.Top := 435;
    lbproduto_preco.Width := 14;
    lbproduto_preco.Height := 13;
    lbproduto_preco.Caption := 'produto_preco:';
    lbproduto_preco.Transparent := True;
    edproduto_preco.SetParentComponent(Self);
    edproduto_preco.Name := 'edproduto_preco';
    edproduto_preco.Left := 221;
    edproduto_preco.Top := 432;
    edproduto_preco.Width := 200;
    edproduto_preco.Height := 21;
    edproduto_preco.Enabled := True;
    edproduto_preco.TabOrder := 15;
    edproduto_preco.Text := 'edproduto_preco';
    edproduto_preco.DataField := 'produto_preco';
    edproduto_preco.DataSource := DataSource;
    lbmargem_acrescimo.SetParentComponent(Self);
    lbmargem_acrescimo.Name := 'lbmargem_acrescimo';
    lbmargem_acrescimo.Left := 24;
    lbmargem_acrescimo.Top := 462;
    lbmargem_acrescimo.Width := 14;
    lbmargem_acrescimo.Height := 13;
    lbmargem_acrescimo.Caption := 'margem_acrescimo:';
    lbmargem_acrescimo.Transparent := True;
    edmargem_acrescimo.SetParentComponent(Self);
    edmargem_acrescimo.Name := 'edmargem_acrescimo';
    edmargem_acrescimo.Left := 221;
    edmargem_acrescimo.Top := 459;
    edmargem_acrescimo.Width := 200;
    edmargem_acrescimo.Height := 21;
    edmargem_acrescimo.Enabled := True;
    edmargem_acrescimo.TabOrder := 16;
    edmargem_acrescimo.Text := 'edmargem_acrescimo';
    edmargem_acrescimo.DataField := 'margem_acrescimo';
    edmargem_acrescimo.DataSource := DataSource;
    lbvalor_acrescimo.SetParentComponent(Self);
    lbvalor_acrescimo.Name := 'lbvalor_acrescimo';
    lbvalor_acrescimo.Left := 24;
    lbvalor_acrescimo.Top := 489;
    lbvalor_acrescimo.Width := 14;
    lbvalor_acrescimo.Height := 13;
    lbvalor_acrescimo.Caption := 'valor_acrescimo:';
    lbvalor_acrescimo.Transparent := True;
    edvalor_acrescimo.SetParentComponent(Self);
    edvalor_acrescimo.Name := 'edvalor_acrescimo';
    edvalor_acrescimo.Left := 221;
    edvalor_acrescimo.Top := 486;
    edvalor_acrescimo.Width := 200;
    edvalor_acrescimo.Height := 21;
    edvalor_acrescimo.Enabled := True;
    edvalor_acrescimo.TabOrder := 17;
    edvalor_acrescimo.Text := 'edvalor_acrescimo';
    edvalor_acrescimo.DataField := 'valor_acrescimo';
    edvalor_acrescimo.DataSource := DataSource;
    lbmargem_desconto.SetParentComponent(Self);
    lbmargem_desconto.Name := 'lbmargem_desconto';
    lbmargem_desconto.Left := 24;
    lbmargem_desconto.Top := 516;
    lbmargem_desconto.Width := 14;
    lbmargem_desconto.Height := 13;
    lbmargem_desconto.Caption := 'margem_desconto:';
    lbmargem_desconto.Transparent := True;
    edmargem_desconto.SetParentComponent(Self);
    edmargem_desconto.Name := 'edmargem_desconto';
    edmargem_desconto.Left := 221;
    edmargem_desconto.Top := 513;
    edmargem_desconto.Width := 200;
    edmargem_desconto.Height := 21;
    edmargem_desconto.Enabled := True;
    edmargem_desconto.TabOrder := 18;
    edmargem_desconto.Text := 'edmargem_desconto';
    edmargem_desconto.DataField := 'margem_desconto';
    edmargem_desconto.DataSource := DataSource;
    lbvalor_desconto.SetParentComponent(Self);
    lbvalor_desconto.Name := 'lbvalor_desconto';
    lbvalor_desconto.Left := 24;
    lbvalor_desconto.Top := 543;
    lbvalor_desconto.Width := 14;
    lbvalor_desconto.Height := 13;
    lbvalor_desconto.Caption := 'valor_desconto:';
    lbvalor_desconto.Transparent := True;
    edvalor_desconto.SetParentComponent(Self);
    edvalor_desconto.Name := 'edvalor_desconto';
    edvalor_desconto.Left := 221;
    edvalor_desconto.Top := 540;
    edvalor_desconto.Width := 200;
    edvalor_desconto.Height := 21;
    edvalor_desconto.Enabled := True;
    edvalor_desconto.TabOrder := 19;
    edvalor_desconto.Text := 'edvalor_desconto';
    edvalor_desconto.DataField := 'valor_desconto';
    edvalor_desconto.DataSource := DataSource;
    lbvalor_total.SetParentComponent(Self);
    lbvalor_total.Name := 'lbvalor_total';
    lbvalor_total.Left := 24;
    lbvalor_total.Top := 570;
    lbvalor_total.Width := 14;
    lbvalor_total.Height := 13;
    lbvalor_total.Caption := 'valor_total:';
    lbvalor_total.Transparent := True;
    edvalor_total.SetParentComponent(Self);
    edvalor_total.Name := 'edvalor_total';
    edvalor_total.Left := 221;
    edvalor_total.Top := 567;
    edvalor_total.Width := 200;
    edvalor_total.Height := 21;
    edvalor_total.Enabled := True;
    edvalor_total.TabOrder := 20;
    edvalor_total.Text := 'edvalor_total';
    edvalor_total.DataField := 'valor_total';
    edvalor_total.DataSource := DataSource;
    lbaliquota_icms.SetParentComponent(Self);
    lbaliquota_icms.Name := 'lbaliquota_icms';
    lbaliquota_icms.Left := 24;
    lbaliquota_icms.Top := 597;
    lbaliquota_icms.Width := 14;
    lbaliquota_icms.Height := 13;
    lbaliquota_icms.Caption := 'aliquota_icms:';
    lbaliquota_icms.Transparent := True;
    edaliquota_icms.SetParentComponent(Self);
    edaliquota_icms.Name := 'edaliquota_icms';
    edaliquota_icms.Left := 221;
    edaliquota_icms.Top := 594;
    edaliquota_icms.Width := 200;
    edaliquota_icms.Height := 21;
    edaliquota_icms.Enabled := True;
    edaliquota_icms.TabOrder := 21;
    edaliquota_icms.Text := 'edaliquota_icms';
    edaliquota_icms.DataField := 'aliquota_icms';
    edaliquota_icms.DataSource := DataSource;
    lbvalor_icms.SetParentComponent(Self);
    lbvalor_icms.Name := 'lbvalor_icms';
    lbvalor_icms.Left := 24;
    lbvalor_icms.Top := 624;
    lbvalor_icms.Width := 14;
    lbvalor_icms.Height := 13;
    lbvalor_icms.Caption := 'valor_icms:';
    lbvalor_icms.Transparent := True;
    edvalor_icms.SetParentComponent(Self);
    edvalor_icms.Name := 'edvalor_icms';
    edvalor_icms.Left := 221;
    edvalor_icms.Top := 621;
    edvalor_icms.Width := 200;
    edvalor_icms.Height := 21;
    edvalor_icms.Enabled := True;
    edvalor_icms.TabOrder := 22;
    edvalor_icms.Text := 'edvalor_icms';
    edvalor_icms.DataField := 'valor_icms';
    edvalor_icms.DataSource := DataSource;
    lbaliquota_icms_red.SetParentComponent(Self);
    lbaliquota_icms_red.Name := 'lbaliquota_icms_red';
    lbaliquota_icms_red.Left := 24;
    lbaliquota_icms_red.Top := 651;
    lbaliquota_icms_red.Width := 14;
    lbaliquota_icms_red.Height := 13;
    lbaliquota_icms_red.Caption := 'aliquota_icms_red:';
    lbaliquota_icms_red.Transparent := True;
    edaliquota_icms_red.SetParentComponent(Self);
    edaliquota_icms_red.Name := 'edaliquota_icms_red';
    edaliquota_icms_red.Left := 221;
    edaliquota_icms_red.Top := 648;
    edaliquota_icms_red.Width := 200;
    edaliquota_icms_red.Height := 21;
    edaliquota_icms_red.Enabled := True;
    edaliquota_icms_red.TabOrder := 23;
    edaliquota_icms_red.Text := 'edaliquota_icms_red';
    edaliquota_icms_red.DataField := 'aliquota_icms_red';
    edaliquota_icms_red.DataSource := DataSource;
    lbvalor_icms_red.SetParentComponent(Self);
    lbvalor_icms_red.Name := 'lbvalor_icms_red';
    lbvalor_icms_red.Left := 24;
    lbvalor_icms_red.Top := 678;
    lbvalor_icms_red.Width := 14;
    lbvalor_icms_red.Height := 13;
    lbvalor_icms_red.Caption := 'valor_icms_red:';
    lbvalor_icms_red.Transparent := True;
    edvalor_icms_red.SetParentComponent(Self);
    edvalor_icms_red.Name := 'edvalor_icms_red';
    edvalor_icms_red.Left := 221;
    edvalor_icms_red.Top := 675;
    edvalor_icms_red.Width := 200;
    edvalor_icms_red.Height := 21;
    edvalor_icms_red.Enabled := True;
    edvalor_icms_red.TabOrder := 24;
    edvalor_icms_red.Text := 'edvalor_icms_red';
    edvalor_icms_red.DataField := 'valor_icms_red';
    edvalor_icms_red.DataSource := DataSource;
    lbvalor_base_calculo_icms.SetParentComponent(Self);
    lbvalor_base_calculo_icms.Name := 'lbvalor_base_calculo_icms';
    lbvalor_base_calculo_icms.Left := 24;
    lbvalor_base_calculo_icms.Top := 705;
    lbvalor_base_calculo_icms.Width := 14;
    lbvalor_base_calculo_icms.Height := 13;
    lbvalor_base_calculo_icms.Caption := 'valor_base_calculo_icms:';
    lbvalor_base_calculo_icms.Transparent := True;
    edvalor_base_calculo_icms.SetParentComponent(Self);
    edvalor_base_calculo_icms.Name := 'edvalor_base_calculo_icms';
    edvalor_base_calculo_icms.Left := 221;
    edvalor_base_calculo_icms.Top := 702;
    edvalor_base_calculo_icms.Width := 200;
    edvalor_base_calculo_icms.Height := 21;
    edvalor_base_calculo_icms.Enabled := True;
    edvalor_base_calculo_icms.TabOrder := 25;
    edvalor_base_calculo_icms.Text := 'edvalor_base_calculo_icms';
    edvalor_base_calculo_icms.DataField := 'valor_base_calculo_icms';
    edvalor_base_calculo_icms.DataSource := DataSource;
    lbcst_id.SetParentComponent(Self);
    lbcst_id.Name := 'lbcst_id';
    lbcst_id.Left := 24;
    lbcst_id.Top := 732;
    lbcst_id.Width := 14;
    lbcst_id.Height := 13;
    lbcst_id.Caption := 'cst_id:';
    lbcst_id.Transparent := True;
    edcst_id.SetParentComponent(Self);
    edcst_id.Name := 'edcst_id';
    edcst_id.Left := 221;
    edcst_id.Top := 729;
    edcst_id.Width := 200;
    edcst_id.Height := 21;
    edcst_id.Enabled := True;
    edcst_id.TabOrder := 26;
    edcst_id.Text := 'edcst_id';
    edcst_id.DataField := 'cst_id';
    edcst_id.DataSource := DataSource;
    lbvalor_base_calculo_pis.SetParentComponent(Self);
    lbvalor_base_calculo_pis.Name := 'lbvalor_base_calculo_pis';
    lbvalor_base_calculo_pis.Left := 24;
    lbvalor_base_calculo_pis.Top := 759;
    lbvalor_base_calculo_pis.Width := 14;
    lbvalor_base_calculo_pis.Height := 13;
    lbvalor_base_calculo_pis.Caption := 'valor_base_calculo_pis:';
    lbvalor_base_calculo_pis.Transparent := True;
    edvalor_base_calculo_pis.SetParentComponent(Self);
    edvalor_base_calculo_pis.Name := 'edvalor_base_calculo_pis';
    edvalor_base_calculo_pis.Left := 221;
    edvalor_base_calculo_pis.Top := 756;
    edvalor_base_calculo_pis.Width := 200;
    edvalor_base_calculo_pis.Height := 21;
    edvalor_base_calculo_pis.Enabled := True;
    edvalor_base_calculo_pis.TabOrder := 27;
    edvalor_base_calculo_pis.Text := 'edvalor_base_calculo_pis';
    edvalor_base_calculo_pis.DataField := 'valor_base_calculo_pis';
    edvalor_base_calculo_pis.DataSource := DataSource;
    lbvalor_pis.SetParentComponent(Self);
    lbvalor_pis.Name := 'lbvalor_pis';
    lbvalor_pis.Left := 24;
    lbvalor_pis.Top := 786;
    lbvalor_pis.Width := 14;
    lbvalor_pis.Height := 13;
    lbvalor_pis.Caption := 'valor_pis:';
    lbvalor_pis.Transparent := True;
    edvalor_pis.SetParentComponent(Self);
    edvalor_pis.Name := 'edvalor_pis';
    edvalor_pis.Left := 221;
    edvalor_pis.Top := 783;
    edvalor_pis.Width := 200;
    edvalor_pis.Height := 21;
    edvalor_pis.Enabled := True;
    edvalor_pis.TabOrder := 28;
    edvalor_pis.Text := 'edvalor_pis';
    edvalor_pis.DataField := 'valor_pis';
    edvalor_pis.DataSource := DataSource;
    lbvalor_base_calculo_cofins.SetParentComponent(Self);
    lbvalor_base_calculo_cofins.Name := 'lbvalor_base_calculo_cofins';
    lbvalor_base_calculo_cofins.Left := 24;
    lbvalor_base_calculo_cofins.Top := 813;
    lbvalor_base_calculo_cofins.Width := 14;
    lbvalor_base_calculo_cofins.Height := 13;
    lbvalor_base_calculo_cofins.Caption := 'valor_base_calculo_cofins:';
    lbvalor_base_calculo_cofins.Transparent := True;
    edvalor_base_calculo_cofins.SetParentComponent(Self);
    edvalor_base_calculo_cofins.Name := 'edvalor_base_calculo_cofins';
    edvalor_base_calculo_cofins.Left := 221;
    edvalor_base_calculo_cofins.Top := 810;
    edvalor_base_calculo_cofins.Width := 200;
    edvalor_base_calculo_cofins.Height := 21;
    edvalor_base_calculo_cofins.Enabled := True;
    edvalor_base_calculo_cofins.TabOrder := 29;
    edvalor_base_calculo_cofins.Text := 'edvalor_base_calculo_cofins';
    edvalor_base_calculo_cofins.DataField := 'valor_base_calculo_cofins';
    edvalor_base_calculo_cofins.DataSource := DataSource;
    lbvalor_cofins.SetParentComponent(Self);
    lbvalor_cofins.Name := 'lbvalor_cofins';
    lbvalor_cofins.Left := 24;
    lbvalor_cofins.Top := 840;
    lbvalor_cofins.Width := 14;
    lbvalor_cofins.Height := 13;
    lbvalor_cofins.Caption := 'valor_cofins:';
    lbvalor_cofins.Transparent := True;
    edvalor_cofins.SetParentComponent(Self);
    edvalor_cofins.Name := 'edvalor_cofins';
    edvalor_cofins.Left := 221;
    edvalor_cofins.Top := 837;
    edvalor_cofins.Width := 200;
    edvalor_cofins.Height := 21;
    edvalor_cofins.Enabled := True;
    edvalor_cofins.TabOrder := 30;
    edvalor_cofins.Text := 'edvalor_cofins';
    edvalor_cofins.DataField := 'valor_cofins';
    edvalor_cofins.DataSource := DataSource;
    lbcsosn_id.SetParentComponent(Self);
    lbcsosn_id.Name := 'lbcsosn_id';
    lbcsosn_id.Left := 24;
    lbcsosn_id.Top := 867;
    lbcsosn_id.Width := 14;
    lbcsosn_id.Height := 13;
    lbcsosn_id.Caption := 'csosn_id:';
    lbcsosn_id.Transparent := True;
    edcsosn_id.SetParentComponent(Self);
    edcsosn_id.Name := 'edcsosn_id';
    edcsosn_id.Left := 221;
    edcsosn_id.Top := 864;
    edcsosn_id.Width := 200;
    edcsosn_id.Height := 21;
    edcsosn_id.Enabled := True;
    edcsosn_id.TabOrder := 31;
    edcsosn_id.Text := 'edcsosn_id';
    edcsosn_id.DataField := 'csosn_id';
    edcsosn_id.DataSource := DataSource;
    lbaliquota_pis.SetParentComponent(Self);
    lbaliquota_pis.Name := 'lbaliquota_pis';
    lbaliquota_pis.Left := 24;
    lbaliquota_pis.Top := 894;
    lbaliquota_pis.Width := 14;
    lbaliquota_pis.Height := 13;
    lbaliquota_pis.Caption := 'aliquota_pis:';
    lbaliquota_pis.Transparent := True;
    edaliquota_pis.SetParentComponent(Self);
    edaliquota_pis.Name := 'edaliquota_pis';
    edaliquota_pis.Left := 221;
    edaliquota_pis.Top := 891;
    edaliquota_pis.Width := 200;
    edaliquota_pis.Height := 21;
    edaliquota_pis.Enabled := True;
    edaliquota_pis.TabOrder := 32;
    edaliquota_pis.Text := 'edaliquota_pis';
    edaliquota_pis.DataField := 'aliquota_pis';
    edaliquota_pis.DataSource := DataSource;
    lbaliquota_cofins.SetParentComponent(Self);
    lbaliquota_cofins.Name := 'lbaliquota_cofins';
    lbaliquota_cofins.Left := 24;
    lbaliquota_cofins.Top := 921;
    lbaliquota_cofins.Width := 14;
    lbaliquota_cofins.Height := 13;
    lbaliquota_cofins.Caption := 'aliquota_cofins:';
    lbaliquota_cofins.Transparent := True;
    edaliquota_cofins.SetParentComponent(Self);
    edaliquota_cofins.Name := 'edaliquota_cofins';
    edaliquota_cofins.Left := 221;
    edaliquota_cofins.Top := 918;
    edaliquota_cofins.Width := 200;
    edaliquota_cofins.Height := 21;
    edaliquota_cofins.Enabled := True;
    edaliquota_cofins.TabOrder := 33;
    edaliquota_cofins.Text := 'edaliquota_cofins';
    edaliquota_cofins.DataField := 'aliquota_cofins';
    edaliquota_cofins.DataSource := DataSource;
    lbcst_pis_id.SetParentComponent(Self);
    lbcst_pis_id.Name := 'lbcst_pis_id';
    lbcst_pis_id.Left := 24;
    lbcst_pis_id.Top := 948;
    lbcst_pis_id.Width := 14;
    lbcst_pis_id.Height := 13;
    lbcst_pis_id.Caption := 'cst_pis_id:';
    lbcst_pis_id.Transparent := True;
    edcst_pis_id.SetParentComponent(Self);
    edcst_pis_id.Name := 'edcst_pis_id';
    edcst_pis_id.Left := 221;
    edcst_pis_id.Top := 945;
    edcst_pis_id.Width := 200;
    edcst_pis_id.Height := 21;
    edcst_pis_id.Enabled := True;
    edcst_pis_id.TabOrder := 34;
    edcst_pis_id.Text := 'edcst_pis_id';
    edcst_pis_id.DataField := 'cst_pis_id';
    edcst_pis_id.DataSource := DataSource;
    lbcst_cofins_id.SetParentComponent(Self);
    lbcst_cofins_id.Name := 'lbcst_cofins_id';
    lbcst_cofins_id.Left := 24;
    lbcst_cofins_id.Top := 975;
    lbcst_cofins_id.Width := 14;
    lbcst_cofins_id.Height := 13;
    lbcst_cofins_id.Caption := 'cst_cofins_id:';
    lbcst_cofins_id.Transparent := True;
    edcst_cofins_id.SetParentComponent(Self);
    edcst_cofins_id.Name := 'edcst_cofins_id';
    edcst_cofins_id.Left := 221;
    edcst_cofins_id.Top := 972;
    edcst_cofins_id.Width := 200;
    edcst_cofins_id.Height := 21;
    edcst_cofins_id.Enabled := True;
    edcst_cofins_id.TabOrder := 35;
    edcst_cofins_id.Text := 'edcst_cofins_id';
    edcst_cofins_id.DataField := 'cst_cofins_id';
    edcst_cofins_id.DataSource := DataSource;
    lbcodigo_natureza_pis_cofins_id.SetParentComponent(Self);
    lbcodigo_natureza_pis_cofins_id.Name := 'lbcodigo_natureza_pis_cofins_id';
    lbcodigo_natureza_pis_cofins_id.Left := 24;
    lbcodigo_natureza_pis_cofins_id.Top := 1002;
    lbcodigo_natureza_pis_cofins_id.Width := 14;
    lbcodigo_natureza_pis_cofins_id.Height := 13;
    lbcodigo_natureza_pis_cofins_id.Caption := 'codigo_natureza_pis_cofins_id:';
    lbcodigo_natureza_pis_cofins_id.Transparent := True;
    edcodigo_natureza_pis_cofins_id.SetParentComponent(Self);
    edcodigo_natureza_pis_cofins_id.Name := 'edcodigo_natureza_pis_cofins_id';
    edcodigo_natureza_pis_cofins_id.Left := 221;
    edcodigo_natureza_pis_cofins_id.Top := 999;
    edcodigo_natureza_pis_cofins_id.Width := 200;
    edcodigo_natureza_pis_cofins_id.Height := 21;
    edcodigo_natureza_pis_cofins_id.Enabled := True;
    edcodigo_natureza_pis_cofins_id.TabOrder := 36;
    edcodigo_natureza_pis_cofins_id.Text := 'edcodigo_natureza_pis_cofins_id';
    edcodigo_natureza_pis_cofins_id.DataField := 'codigo_natureza_pis_cofins_id';
    edcodigo_natureza_pis_cofins_id.DataSource := DataSource;
    lbaliquota_id.SetParentComponent(Self);
    lbaliquota_id.Name := 'lbaliquota_id';
    lbaliquota_id.Left := 24;
    lbaliquota_id.Top := 1029;
    lbaliquota_id.Width := 14;
    lbaliquota_id.Height := 13;
    lbaliquota_id.Caption := 'aliquota_id:';
    lbaliquota_id.Transparent := True;
    edaliquota_id.SetParentComponent(Self);
    edaliquota_id.Name := 'edaliquota_id';
    edaliquota_id.Left := 221;
    edaliquota_id.Top := 1026;
    edaliquota_id.Width := 200;
    edaliquota_id.Height := 21;
    edaliquota_id.Enabled := True;
    edaliquota_id.TabOrder := 37;
    edaliquota_id.Text := 'edaliquota_id';
    edaliquota_id.DataField := 'aliquota_id';
    edaliquota_id.DataSource := DataSource;
    lbproduto_preco_custo.SetParentComponent(Self);
    lbproduto_preco_custo.Name := 'lbproduto_preco_custo';
    lbproduto_preco_custo.Left := 24;
    lbproduto_preco_custo.Top := 1056;
    lbproduto_preco_custo.Width := 14;
    lbproduto_preco_custo.Height := 13;
    lbproduto_preco_custo.Caption := 'produto_preco_custo:';
    lbproduto_preco_custo.Transparent := True;
    edproduto_preco_custo.SetParentComponent(Self);
    edproduto_preco_custo.Name := 'edproduto_preco_custo';
    edproduto_preco_custo.Left := 221;
    edproduto_preco_custo.Top := 1053;
    edproduto_preco_custo.Width := 200;
    edproduto_preco_custo.Height := 21;
    edproduto_preco_custo.Enabled := True;
    edproduto_preco_custo.TabOrder := 38;
    edproduto_preco_custo.Text := 'edproduto_preco_custo';
    edproduto_preco_custo.DataField := 'produto_preco_custo';
    edproduto_preco_custo.DataSource := DataSource;
    lbcodigo_produto_movimenta_estoque.SetParentComponent(Self);
    lbcodigo_produto_movimenta_estoque.Name := 'lbcodigo_produto_movimenta_estoque';
    lbcodigo_produto_movimenta_estoque.Left := 24;
    lbcodigo_produto_movimenta_estoque.Top := 1083;
    lbcodigo_produto_movimenta_estoque.Width := 14;
    lbcodigo_produto_movimenta_estoque.Height := 13;
    lbcodigo_produto_movimenta_estoque.Caption := 'codigo_produto_movimenta_estoque:';
    lbcodigo_produto_movimenta_estoque.Transparent := True;
    edcodigo_produto_movimenta_estoque.SetParentComponent(Self);
    edcodigo_produto_movimenta_estoque.Name := 'edcodigo_produto_movimenta_estoque';
    edcodigo_produto_movimenta_estoque.Left := 221;
    edcodigo_produto_movimenta_estoque.Top := 1080;
    edcodigo_produto_movimenta_estoque.Width := 200;
    edcodigo_produto_movimenta_estoque.Height := 21;
    edcodigo_produto_movimenta_estoque.Enabled := True;
    edcodigo_produto_movimenta_estoque.TabOrder := 39;
    edcodigo_produto_movimenta_estoque.Text := 'edcodigo_produto_movimenta_estoque';
    edcodigo_produto_movimenta_estoque.DataField := 'codigo_produto_movimenta_estoque';
    edcodigo_produto_movimenta_estoque.DataSource := DataSource;
    lbfuncionario_id.SetParentComponent(Self);
    lbfuncionario_id.Name := 'lbfuncionario_id';
    lbfuncionario_id.Left := 24;
    lbfuncionario_id.Top := 1110;
    lbfuncionario_id.Width := 14;
    lbfuncionario_id.Height := 13;
    lbfuncionario_id.Caption := 'funcionario_id:';
    lbfuncionario_id.Transparent := True;
    edfuncionario_id.SetParentComponent(Self);
    edfuncionario_id.Name := 'edfuncionario_id';
    edfuncionario_id.Left := 221;
    edfuncionario_id.Top := 1107;
    edfuncionario_id.Width := 200;
    edfuncionario_id.Height := 21;
    edfuncionario_id.Enabled := True;
    edfuncionario_id.TabOrder := 40;
    edfuncionario_id.Text := 'edfuncionario_id';
    edfuncionario_id.DataField := 'funcionario_id';
    edfuncionario_id.DataSource := DataSource;
    lbitem_movimenta_estoque.SetParentComponent(Self);
    lbitem_movimenta_estoque.Name := 'lbitem_movimenta_estoque';
    lbitem_movimenta_estoque.Left := 24;
    lbitem_movimenta_estoque.Top := 1137;
    lbitem_movimenta_estoque.Width := 14;
    lbitem_movimenta_estoque.Height := 13;
    lbitem_movimenta_estoque.Caption := 'item_movimenta_estoque:';
    lbitem_movimenta_estoque.Transparent := True;
    editem_movimenta_estoque.SetParentComponent(Self);
    editem_movimenta_estoque.Name := 'editem_movimenta_estoque';
    editem_movimenta_estoque.Left := 221;
    editem_movimenta_estoque.Top := 1134;
    editem_movimenta_estoque.Width := 200;
    editem_movimenta_estoque.Height := 21;
    editem_movimenta_estoque.Enabled := True;
    editem_movimenta_estoque.TabOrder := 41;
    editem_movimenta_estoque.Text := 'editem_movimenta_estoque';
    editem_movimenta_estoque.DataField := 'item_movimenta_estoque';
    editem_movimenta_estoque.DataSource := DataSource;
    lbquantidade_embalagem.SetParentComponent(Self);
    lbquantidade_embalagem.Name := 'lbquantidade_embalagem';
    lbquantidade_embalagem.Left := 24;
    lbquantidade_embalagem.Top := 1164;
    lbquantidade_embalagem.Width := 14;
    lbquantidade_embalagem.Height := 13;
    lbquantidade_embalagem.Caption := 'quantidade_embalagem:';
    lbquantidade_embalagem.Transparent := True;
    edquantidade_embalagem.SetParentComponent(Self);
    edquantidade_embalagem.Name := 'edquantidade_embalagem';
    edquantidade_embalagem.Left := 221;
    edquantidade_embalagem.Top := 1161;
    edquantidade_embalagem.Width := 200;
    edquantidade_embalagem.Height := 21;
    edquantidade_embalagem.Enabled := True;
    edquantidade_embalagem.TabOrder := 42;
    edquantidade_embalagem.Text := 'edquantidade_embalagem';
    edquantidade_embalagem.DataField := 'quantidade_embalagem';
    edquantidade_embalagem.DataSource := DataSource;
    lbgrade_produto_id.SetParentComponent(Self);
    lbgrade_produto_id.Name := 'lbgrade_produto_id';
    lbgrade_produto_id.Left := 24;
    lbgrade_produto_id.Top := 1191;
    lbgrade_produto_id.Width := 14;
    lbgrade_produto_id.Height := 13;
    lbgrade_produto_id.Caption := 'grade_produto_id:';
    lbgrade_produto_id.Transparent := True;
    edgrade_produto_id.SetParentComponent(Self);
    edgrade_produto_id.Name := 'edgrade_produto_id';
    edgrade_produto_id.Left := 221;
    edgrade_produto_id.Top := 1188;
    edgrade_produto_id.Width := 200;
    edgrade_produto_id.Height := 21;
    edgrade_produto_id.Enabled := True;
    edgrade_produto_id.TabOrder := 43;
    edgrade_produto_id.Text := 'edgrade_produto_id';
    edgrade_produto_id.DataField := 'grade_produto_id';
    edgrade_produto_id.DataSource := DataSource;
    lbproduto_nome.SetParentComponent(Self);
    lbproduto_nome.Name := 'lbproduto_nome';
    lbproduto_nome.Left := 24;
    lbproduto_nome.Top := 1218;
    lbproduto_nome.Width := 14;
    lbproduto_nome.Height := 13;
    lbproduto_nome.Caption := 'produto_nome:';
    lbproduto_nome.Transparent := True;
    edproduto_nome.SetParentComponent(Self);
    edproduto_nome.Name := 'edproduto_nome';
    edproduto_nome.Left := 221;
    edproduto_nome.Top := 1215;
    edproduto_nome.Width := 200;
    edproduto_nome.Height := 21;
    edproduto_nome.Enabled := True;
    edproduto_nome.TabOrder := 44;
    edproduto_nome.Text := 'edproduto_nome';
    edproduto_nome.DataField := 'produto_nome';
    edproduto_nome.DataSource := DataSource;
    lbitem_quantidade_movimenta_estoque.SetParentComponent(Self);
    lbitem_quantidade_movimenta_estoque.Name := 'lbitem_quantidade_movimenta_estoque';
    lbitem_quantidade_movimenta_estoque.Left := 24;
    lbitem_quantidade_movimenta_estoque.Top := 1245;
    lbitem_quantidade_movimenta_estoque.Width := 14;
    lbitem_quantidade_movimenta_estoque.Height := 13;
    lbitem_quantidade_movimenta_estoque.Caption := 'item_quantidade_movimenta_estoque:';
    lbitem_quantidade_movimenta_estoque.Transparent := True;
    editem_quantidade_movimenta_estoque.SetParentComponent(Self);
    editem_quantidade_movimenta_estoque.Name := 'editem_quantidade_movimenta_estoque';
    editem_quantidade_movimenta_estoque.Left := 221;
    editem_quantidade_movimenta_estoque.Top := 1242;
    editem_quantidade_movimenta_estoque.Width := 200;
    editem_quantidade_movimenta_estoque.Height := 21;
    editem_quantidade_movimenta_estoque.Enabled := True;
    editem_quantidade_movimenta_estoque.TabOrder := 45;
    editem_quantidade_movimenta_estoque.Text := 'editem_quantidade_movimenta_estoque';
    editem_quantidade_movimenta_estoque.DataField := 'item_quantidade_movimenta_estoque';
    editem_quantidade_movimenta_estoque.DataSource := DataSource;
    lbscan_promocoes_id.SetParentComponent(Self);
    lbscan_promocoes_id.Name := 'lbscan_promocoes_id';
    lbscan_promocoes_id.Left := 24;
    lbscan_promocoes_id.Top := 1272;
    lbscan_promocoes_id.Width := 14;
    lbscan_promocoes_id.Height := 13;
    lbscan_promocoes_id.Caption := 'scan_promocoes_id:';
    lbscan_promocoes_id.Transparent := True;
    edscan_promocoes_id.SetParentComponent(Self);
    edscan_promocoes_id.Name := 'edscan_promocoes_id';
    edscan_promocoes_id.Left := 221;
    edscan_promocoes_id.Top := 1269;
    edscan_promocoes_id.Width := 200;
    edscan_promocoes_id.Height := 21;
    edscan_promocoes_id.Enabled := True;
    edscan_promocoes_id.TabOrder := 46;
    edscan_promocoes_id.Text := 'edscan_promocoes_id';
    edscan_promocoes_id.DataField := 'scan_promocoes_id';
    edscan_promocoes_id.DataSource := DataSource;
    lbvalor_desconto_scanntech.SetParentComponent(Self);
    lbvalor_desconto_scanntech.Name := 'lbvalor_desconto_scanntech';
    lbvalor_desconto_scanntech.Left := 24;
    lbvalor_desconto_scanntech.Top := 1299;
    lbvalor_desconto_scanntech.Width := 14;
    lbvalor_desconto_scanntech.Height := 13;
    lbvalor_desconto_scanntech.Caption := 'valor_desconto_scanntech:';
    lbvalor_desconto_scanntech.Transparent := True;
    edvalor_desconto_scanntech.SetParentComponent(Self);
    edvalor_desconto_scanntech.Name := 'edvalor_desconto_scanntech';
    edvalor_desconto_scanntech.Left := 221;
    edvalor_desconto_scanntech.Top := 1296;
    edvalor_desconto_scanntech.Width := 200;
    edvalor_desconto_scanntech.Height := 21;
    edvalor_desconto_scanntech.Enabled := True;
    edvalor_desconto_scanntech.TabOrder := 47;
    edvalor_desconto_scanntech.Text := 'edvalor_desconto_scanntech';
    edvalor_desconto_scanntech.DataField := 'valor_desconto_scanntech';
    edvalor_desconto_scanntech.DataSource := DataSource;
    lbvalor_base_calculo_fcp_icms.SetParentComponent(Self);
    lbvalor_base_calculo_fcp_icms.Name := 'lbvalor_base_calculo_fcp_icms';
    lbvalor_base_calculo_fcp_icms.Left := 24;
    lbvalor_base_calculo_fcp_icms.Top := 1326;
    lbvalor_base_calculo_fcp_icms.Width := 14;
    lbvalor_base_calculo_fcp_icms.Height := 13;
    lbvalor_base_calculo_fcp_icms.Caption := 'valor_base_calculo_fcp_icms:';
    lbvalor_base_calculo_fcp_icms.Transparent := True;
    edvalor_base_calculo_fcp_icms.SetParentComponent(Self);
    edvalor_base_calculo_fcp_icms.Name := 'edvalor_base_calculo_fcp_icms';
    edvalor_base_calculo_fcp_icms.Left := 221;
    edvalor_base_calculo_fcp_icms.Top := 1323;
    edvalor_base_calculo_fcp_icms.Width := 200;
    edvalor_base_calculo_fcp_icms.Height := 21;
    edvalor_base_calculo_fcp_icms.Enabled := True;
    edvalor_base_calculo_fcp_icms.TabOrder := 48;
    edvalor_base_calculo_fcp_icms.Text := 'edvalor_base_calculo_fcp_icms';
    edvalor_base_calculo_fcp_icms.DataField := 'valor_base_calculo_fcp_icms';
    edvalor_base_calculo_fcp_icms.DataSource := DataSource;
    lbaliquota_fcp_icms.SetParentComponent(Self);
    lbaliquota_fcp_icms.Name := 'lbaliquota_fcp_icms';
    lbaliquota_fcp_icms.Left := 24;
    lbaliquota_fcp_icms.Top := 1353;
    lbaliquota_fcp_icms.Width := 14;
    lbaliquota_fcp_icms.Height := 13;
    lbaliquota_fcp_icms.Caption := 'aliquota_fcp_icms:';
    lbaliquota_fcp_icms.Transparent := True;
    edaliquota_fcp_icms.SetParentComponent(Self);
    edaliquota_fcp_icms.Name := 'edaliquota_fcp_icms';
    edaliquota_fcp_icms.Left := 221;
    edaliquota_fcp_icms.Top := 1350;
    edaliquota_fcp_icms.Width := 200;
    edaliquota_fcp_icms.Height := 21;
    edaliquota_fcp_icms.Enabled := True;
    edaliquota_fcp_icms.TabOrder := 49;
    edaliquota_fcp_icms.Text := 'edaliquota_fcp_icms';
    edaliquota_fcp_icms.DataField := 'aliquota_fcp_icms';
    edaliquota_fcp_icms.DataSource := DataSource;
    lbvalor_fcp_icms.SetParentComponent(Self);
    lbvalor_fcp_icms.Name := 'lbvalor_fcp_icms';
    lbvalor_fcp_icms.Left := 24;
    lbvalor_fcp_icms.Top := 1380;
    lbvalor_fcp_icms.Width := 14;
    lbvalor_fcp_icms.Height := 13;
    lbvalor_fcp_icms.Caption := 'valor_fcp_icms:';
    lbvalor_fcp_icms.Transparent := True;
    edvalor_fcp_icms.SetParentComponent(Self);
    edvalor_fcp_icms.Name := 'edvalor_fcp_icms';
    edvalor_fcp_icms.Left := 221;
    edvalor_fcp_icms.Top := 1377;
    edvalor_fcp_icms.Width := 200;
    edvalor_fcp_icms.Height := 21;
    edvalor_fcp_icms.Enabled := True;
    edvalor_fcp_icms.TabOrder := 50;
    edvalor_fcp_icms.Text := 'edvalor_fcp_icms';
    edvalor_fcp_icms.DataField := 'valor_fcp_icms';
    edvalor_fcp_icms.DataSource := DataSource;
    lbvalor_base_calculo_fcp_retida.SetParentComponent(Self);
    lbvalor_base_calculo_fcp_retida.Name := 'lbvalor_base_calculo_fcp_retida';
    lbvalor_base_calculo_fcp_retida.Left := 24;
    lbvalor_base_calculo_fcp_retida.Top := 1407;
    lbvalor_base_calculo_fcp_retida.Width := 14;
    lbvalor_base_calculo_fcp_retida.Height := 13;
    lbvalor_base_calculo_fcp_retida.Caption := 'valor_base_calculo_fcp_retida:';
    lbvalor_base_calculo_fcp_retida.Transparent := True;
    edvalor_base_calculo_fcp_retida.SetParentComponent(Self);
    edvalor_base_calculo_fcp_retida.Name := 'edvalor_base_calculo_fcp_retida';
    edvalor_base_calculo_fcp_retida.Left := 221;
    edvalor_base_calculo_fcp_retida.Top := 1404;
    edvalor_base_calculo_fcp_retida.Width := 200;
    edvalor_base_calculo_fcp_retida.Height := 21;
    edvalor_base_calculo_fcp_retida.Enabled := True;
    edvalor_base_calculo_fcp_retida.TabOrder := 51;
    edvalor_base_calculo_fcp_retida.Text := 'edvalor_base_calculo_fcp_retida';
    edvalor_base_calculo_fcp_retida.DataField := 'valor_base_calculo_fcp_retida';
    edvalor_base_calculo_fcp_retida.DataSource := DataSource;
    lbaliquota_fcp_retida.SetParentComponent(Self);
    lbaliquota_fcp_retida.Name := 'lbaliquota_fcp_retida';
    lbaliquota_fcp_retida.Left := 24;
    lbaliquota_fcp_retida.Top := 1434;
    lbaliquota_fcp_retida.Width := 14;
    lbaliquota_fcp_retida.Height := 13;
    lbaliquota_fcp_retida.Caption := 'aliquota_fcp_retida:';
    lbaliquota_fcp_retida.Transparent := True;
    edaliquota_fcp_retida.SetParentComponent(Self);
    edaliquota_fcp_retida.Name := 'edaliquota_fcp_retida';
    edaliquota_fcp_retida.Left := 221;
    edaliquota_fcp_retida.Top := 1431;
    edaliquota_fcp_retida.Width := 200;
    edaliquota_fcp_retida.Height := 21;
    edaliquota_fcp_retida.Enabled := True;
    edaliquota_fcp_retida.TabOrder := 52;
    edaliquota_fcp_retida.Text := 'edaliquota_fcp_retida';
    edaliquota_fcp_retida.DataField := 'aliquota_fcp_retida';
    edaliquota_fcp_retida.DataSource := DataSource;
    lbvalor_fcp_retida.SetParentComponent(Self);
    lbvalor_fcp_retida.Name := 'lbvalor_fcp_retida';
    lbvalor_fcp_retida.Left := 24;
    lbvalor_fcp_retida.Top := 1461;
    lbvalor_fcp_retida.Width := 14;
    lbvalor_fcp_retida.Height := 13;
    lbvalor_fcp_retida.Caption := 'valor_fcp_retida:';
    lbvalor_fcp_retida.Transparent := True;
    edvalor_fcp_retida.SetParentComponent(Self);
    edvalor_fcp_retida.Name := 'edvalor_fcp_retida';
    edvalor_fcp_retida.Left := 221;
    edvalor_fcp_retida.Top := 1458;
    edvalor_fcp_retida.Width := 200;
    edvalor_fcp_retida.Height := 21;
    edvalor_fcp_retida.Enabled := True;
    edvalor_fcp_retida.TabOrder := 53;
    edvalor_fcp_retida.Text := 'edvalor_fcp_retida';
    edvalor_fcp_retida.DataField := 'valor_fcp_retida';
    edvalor_fcp_retida.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 1488;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 1485;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 54;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 1515;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 1512;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 55;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 1542;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 1539;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 56;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 1569;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 1566;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 57;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 1596;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 1593;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 58;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Itens_CuponsDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Itens_CuponsDataset.SetParentComponent(Self);
    Itens_CuponsDataset.Name := 'Itens_CuponsDataset';
    Itens_CuponsDataset.AfterApplyUpdates := Itens_CuponsDatasetAfterApplyUpdates;
    Itens_CuponsDataset.EntitySetName := 'Itens_Cupons';
    Itens_CuponsDataset.Connection := DMConnection.ApiConnection;
    Itens_CuponsDataset.Left := 176;
    Itens_CuponsDataset.Top := 8;
    Itens_CuponsDatasetid.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetid.Name := 'Itens_CuponsDatasetid';
    Itens_CuponsDatasetid.FieldName := 'id';
    Itens_CuponsDatasetid.Required := True;
    Itens_CuponsDatasetaliado_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliado_id.Name := 'Itens_CuponsDatasetaliado_id';
    Itens_CuponsDatasetaliado_id.FieldName := 'aliado_id';
    Itens_CuponsDatasetaliado_id.Required := True;
    Itens_CuponsDatasetdata_base_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetdata_base_id.Name := 'Itens_CuponsDatasetdata_base_id';
    Itens_CuponsDatasetdata_base_id.FieldName := 'data_base_id';
    Itens_CuponsDatasetdata_base_id.Required := True;
    Itens_CuponsDatasetcupons_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcupons_id.Name := 'Itens_CuponsDatasetcupons_id';
    Itens_CuponsDatasetcupons_id.FieldName := 'cupons_id';
    Itens_CuponsDatasetcupons_id.Required := True;
    Itens_CuponsDatasetproduto_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetproduto_id.Name := 'Itens_CuponsDatasetproduto_id';
    Itens_CuponsDatasetproduto_id.FieldName := 'produto_id';
    Itens_CuponsDatasetproduto_id.Required := True;
    Itens_CuponsDatasetunidade_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetunidade_id.Name := 'Itens_CuponsDatasetunidade_id';
    Itens_CuponsDatasetunidade_id.FieldName := 'unidade_id';
    Itens_CuponsDatasetunidade_id.Required := False;
    Itens_CuponsDatasetitem.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetitem.Name := 'Itens_CuponsDatasetitem';
    Itens_CuponsDatasetitem.FieldName := 'item';
    Itens_CuponsDatasetitem.Required := False;
    Itens_CuponsDatasetcfop_cfop.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcfop_cfop.Name := 'Itens_CuponsDatasetcfop_cfop';
    Itens_CuponsDatasetcfop_cfop.FieldName := 'cfop_cfop';
    Itens_CuponsDatasetcfop_cfop.Required := True;
    Itens_CuponsDatasetcfop_cfop.Size := 255;
    Itens_CuponsDatasetquantidade.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetquantidade.Name := 'Itens_CuponsDatasetquantidade';
    Itens_CuponsDatasetquantidade.FieldName := 'quantidade';
    Itens_CuponsDatasetquantidade.Required := False;
    Itens_CuponsDatasetproduto_preco.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetproduto_preco.Name := 'Itens_CuponsDatasetproduto_preco';
    Itens_CuponsDatasetproduto_preco.FieldName := 'produto_preco';
    Itens_CuponsDatasetproduto_preco.Required := False;
    Itens_CuponsDatasetmargem_acrescimo.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetmargem_acrescimo.Name := 'Itens_CuponsDatasetmargem_acrescimo';
    Itens_CuponsDatasetmargem_acrescimo.FieldName := 'margem_acrescimo';
    Itens_CuponsDatasetmargem_acrescimo.Required := False;
    Itens_CuponsDatasetvalor_acrescimo.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_acrescimo.Name := 'Itens_CuponsDatasetvalor_acrescimo';
    Itens_CuponsDatasetvalor_acrescimo.FieldName := 'valor_acrescimo';
    Itens_CuponsDatasetvalor_acrescimo.Required := False;
    Itens_CuponsDatasetmargem_desconto.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetmargem_desconto.Name := 'Itens_CuponsDatasetmargem_desconto';
    Itens_CuponsDatasetmargem_desconto.FieldName := 'margem_desconto';
    Itens_CuponsDatasetmargem_desconto.Required := False;
    Itens_CuponsDatasetvalor_desconto.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_desconto.Name := 'Itens_CuponsDatasetvalor_desconto';
    Itens_CuponsDatasetvalor_desconto.FieldName := 'valor_desconto';
    Itens_CuponsDatasetvalor_desconto.Required := False;
    Itens_CuponsDatasetvalor_total.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_total.Name := 'Itens_CuponsDatasetvalor_total';
    Itens_CuponsDatasetvalor_total.FieldName := 'valor_total';
    Itens_CuponsDatasetvalor_total.Required := True;
    Itens_CuponsDatasetaliquota_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_icms.Name := 'Itens_CuponsDatasetaliquota_icms';
    Itens_CuponsDatasetaliquota_icms.FieldName := 'aliquota_icms';
    Itens_CuponsDatasetaliquota_icms.Required := False;
    Itens_CuponsDatasetvalor_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_icms.Name := 'Itens_CuponsDatasetvalor_icms';
    Itens_CuponsDatasetvalor_icms.FieldName := 'valor_icms';
    Itens_CuponsDatasetvalor_icms.Required := False;
    Itens_CuponsDatasetaliquota_icms_red.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_icms_red.Name := 'Itens_CuponsDatasetaliquota_icms_red';
    Itens_CuponsDatasetaliquota_icms_red.FieldName := 'aliquota_icms_red';
    Itens_CuponsDatasetaliquota_icms_red.Required := False;
    Itens_CuponsDatasetvalor_icms_red.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_icms_red.Name := 'Itens_CuponsDatasetvalor_icms_red';
    Itens_CuponsDatasetvalor_icms_red.FieldName := 'valor_icms_red';
    Itens_CuponsDatasetvalor_icms_red.Required := False;
    Itens_CuponsDatasetvalor_base_calculo_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_icms.Name := 'Itens_CuponsDatasetvalor_base_calculo_icms';
    Itens_CuponsDatasetvalor_base_calculo_icms.FieldName := 'valor_base_calculo_icms';
    Itens_CuponsDatasetvalor_base_calculo_icms.Required := False;
    Itens_CuponsDatasetcst_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcst_id.Name := 'Itens_CuponsDatasetcst_id';
    Itens_CuponsDatasetcst_id.FieldName := 'cst_id';
    Itens_CuponsDatasetcst_id.Required := False;
    Itens_CuponsDatasetcst_id.Size := 255;
    Itens_CuponsDatasetvalor_base_calculo_pis.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_pis.Name := 'Itens_CuponsDatasetvalor_base_calculo_pis';
    Itens_CuponsDatasetvalor_base_calculo_pis.FieldName := 'valor_base_calculo_pis';
    Itens_CuponsDatasetvalor_base_calculo_pis.Required := False;
    Itens_CuponsDatasetvalor_pis.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_pis.Name := 'Itens_CuponsDatasetvalor_pis';
    Itens_CuponsDatasetvalor_pis.FieldName := 'valor_pis';
    Itens_CuponsDatasetvalor_pis.Required := False;
    Itens_CuponsDatasetvalor_base_calculo_cofins.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_cofins.Name := 'Itens_CuponsDatasetvalor_base_calculo_cofins';
    Itens_CuponsDatasetvalor_base_calculo_cofins.FieldName := 'valor_base_calculo_cofins';
    Itens_CuponsDatasetvalor_base_calculo_cofins.Required := False;
    Itens_CuponsDatasetvalor_cofins.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_cofins.Name := 'Itens_CuponsDatasetvalor_cofins';
    Itens_CuponsDatasetvalor_cofins.FieldName := 'valor_cofins';
    Itens_CuponsDatasetvalor_cofins.Required := False;
    Itens_CuponsDatasetcsosn_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcsosn_id.Name := 'Itens_CuponsDatasetcsosn_id';
    Itens_CuponsDatasetcsosn_id.FieldName := 'csosn_id';
    Itens_CuponsDatasetcsosn_id.Required := False;
    Itens_CuponsDatasetcsosn_id.Size := 255;
    Itens_CuponsDatasetaliquota_pis.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_pis.Name := 'Itens_CuponsDatasetaliquota_pis';
    Itens_CuponsDatasetaliquota_pis.FieldName := 'aliquota_pis';
    Itens_CuponsDatasetaliquota_pis.Required := False;
    Itens_CuponsDatasetaliquota_cofins.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_cofins.Name := 'Itens_CuponsDatasetaliquota_cofins';
    Itens_CuponsDatasetaliquota_cofins.FieldName := 'aliquota_cofins';
    Itens_CuponsDatasetaliquota_cofins.Required := False;
    Itens_CuponsDatasetcst_pis_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcst_pis_id.Name := 'Itens_CuponsDatasetcst_pis_id';
    Itens_CuponsDatasetcst_pis_id.FieldName := 'cst_pis_id';
    Itens_CuponsDatasetcst_pis_id.Required := False;
    Itens_CuponsDatasetcst_pis_id.Size := 255;
    Itens_CuponsDatasetcst_cofins_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcst_cofins_id.Name := 'Itens_CuponsDatasetcst_cofins_id';
    Itens_CuponsDatasetcst_cofins_id.FieldName := 'cst_cofins_id';
    Itens_CuponsDatasetcst_cofins_id.Required := False;
    Itens_CuponsDatasetcst_cofins_id.Size := 255;
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.Name := 'Itens_CuponsDatasetcodigo_natureza_pis_cofins_id';
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.FieldName := 'codigo_natureza_pis_cofins_id';
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.Required := False;
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.Size := 255;
    Itens_CuponsDatasetaliquota_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_id.Name := 'Itens_CuponsDatasetaliquota_id';
    Itens_CuponsDatasetaliquota_id.FieldName := 'aliquota_id';
    Itens_CuponsDatasetaliquota_id.Required := False;
    Itens_CuponsDatasetproduto_preco_custo.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetproduto_preco_custo.Name := 'Itens_CuponsDatasetproduto_preco_custo';
    Itens_CuponsDatasetproduto_preco_custo.FieldName := 'produto_preco_custo';
    Itens_CuponsDatasetproduto_preco_custo.Required := False;
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque.Name := 'Itens_CuponsDatasetcodigo_produto_movimenta_estoque';
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque.FieldName := 'codigo_produto_movimenta_estoque';
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque.Required := False;
    Itens_CuponsDatasetfuncionario_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetfuncionario_id.Name := 'Itens_CuponsDatasetfuncionario_id';
    Itens_CuponsDatasetfuncionario_id.FieldName := 'funcionario_id';
    Itens_CuponsDatasetfuncionario_id.Required := False;
    Itens_CuponsDatasetitem_movimenta_estoque.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetitem_movimenta_estoque.Name := 'Itens_CuponsDatasetitem_movimenta_estoque';
    Itens_CuponsDatasetitem_movimenta_estoque.FieldName := 'item_movimenta_estoque';
    Itens_CuponsDatasetitem_movimenta_estoque.Required := True;
    Itens_CuponsDatasetquantidade_embalagem.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetquantidade_embalagem.Name := 'Itens_CuponsDatasetquantidade_embalagem';
    Itens_CuponsDatasetquantidade_embalagem.FieldName := 'quantidade_embalagem';
    Itens_CuponsDatasetquantidade_embalagem.Required := False;
    Itens_CuponsDatasetgrade_produto_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetgrade_produto_id.Name := 'Itens_CuponsDatasetgrade_produto_id';
    Itens_CuponsDatasetgrade_produto_id.FieldName := 'grade_produto_id';
    Itens_CuponsDatasetgrade_produto_id.Required := False;
    Itens_CuponsDatasetproduto_nome.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetproduto_nome.Name := 'Itens_CuponsDatasetproduto_nome';
    Itens_CuponsDatasetproduto_nome.FieldName := 'produto_nome';
    Itens_CuponsDatasetproduto_nome.Required := False;
    Itens_CuponsDatasetproduto_nome.Size := 255;
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque.Name := 'Itens_CuponsDatasetitem_quantidade_movimenta_estoque';
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque.FieldName := 'item_quantidade_movimenta_estoque';
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque.Required := False;
    Itens_CuponsDatasetscan_promocoes_id.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetscan_promocoes_id.Name := 'Itens_CuponsDatasetscan_promocoes_id';
    Itens_CuponsDatasetscan_promocoes_id.FieldName := 'scan_promocoes_id';
    Itens_CuponsDatasetscan_promocoes_id.Required := False;
    Itens_CuponsDatasetvalor_desconto_scanntech.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_desconto_scanntech.Name := 'Itens_CuponsDatasetvalor_desconto_scanntech';
    Itens_CuponsDatasetvalor_desconto_scanntech.FieldName := 'valor_desconto_scanntech';
    Itens_CuponsDatasetvalor_desconto_scanntech.Required := False;
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms.Name := 'Itens_CuponsDatasetvalor_base_calculo_fcp_icms';
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms.FieldName := 'valor_base_calculo_fcp_icms';
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms.Required := False;
    Itens_CuponsDatasetaliquota_fcp_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_fcp_icms.Name := 'Itens_CuponsDatasetaliquota_fcp_icms';
    Itens_CuponsDatasetaliquota_fcp_icms.FieldName := 'aliquota_fcp_icms';
    Itens_CuponsDatasetaliquota_fcp_icms.Required := False;
    Itens_CuponsDatasetvalor_fcp_icms.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_fcp_icms.Name := 'Itens_CuponsDatasetvalor_fcp_icms';
    Itens_CuponsDatasetvalor_fcp_icms.FieldName := 'valor_fcp_icms';
    Itens_CuponsDatasetvalor_fcp_icms.Required := False;
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida.Name := 'Itens_CuponsDatasetvalor_base_calculo_fcp_retida';
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida.FieldName := 'valor_base_calculo_fcp_retida';
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida.Required := False;
    Itens_CuponsDatasetaliquota_fcp_retida.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetaliquota_fcp_retida.Name := 'Itens_CuponsDatasetaliquota_fcp_retida';
    Itens_CuponsDatasetaliquota_fcp_retida.FieldName := 'aliquota_fcp_retida';
    Itens_CuponsDatasetaliquota_fcp_retida.Required := False;
    Itens_CuponsDatasetvalor_fcp_retida.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetvalor_fcp_retida.Name := 'Itens_CuponsDatasetvalor_fcp_retida';
    Itens_CuponsDatasetvalor_fcp_retida.FieldName := 'valor_fcp_retida';
    Itens_CuponsDatasetvalor_fcp_retida.Required := False;
    Itens_CuponsDatasetcodigo_interno.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetcodigo_interno.Name := 'Itens_CuponsDatasetcodigo_interno';
    Itens_CuponsDatasetcodigo_interno.FieldName := 'codigo_interno';
    Itens_CuponsDatasetcodigo_interno.Required := True;
    Itens_CuponsDatasetexcluido.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetexcluido.Name := 'Itens_CuponsDatasetexcluido';
    Itens_CuponsDatasetexcluido.FieldName := 'excluido';
    Itens_CuponsDatasetexcluido.Required := False;
    Itens_CuponsDatasetinclusao.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetinclusao.Name := 'Itens_CuponsDatasetinclusao';
    Itens_CuponsDatasetinclusao.FieldName := 'inclusao';
    Itens_CuponsDatasetinclusao.Required := False;
    Itens_CuponsDatasetalteracao.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetalteracao.Name := 'Itens_CuponsDatasetalteracao';
    Itens_CuponsDatasetalteracao.FieldName := 'alteracao';
    Itens_CuponsDatasetalteracao.Required := False;
    Itens_CuponsDatasetexclusao.SetParentComponent(Itens_CuponsDataset);
    Itens_CuponsDatasetexclusao.Name := 'Itens_CuponsDatasetexclusao';
    Itens_CuponsDatasetexclusao.FieldName := 'exclusao';
    Itens_CuponsDatasetexclusao.Required := False;
    XDataClientItens_CuponsGet.SetParentComponent(Self);
    XDataClientItens_CuponsGet.Name := 'XDataClientItens_CuponsGet';
    XDataClientItens_CuponsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientItens_CuponsGet, Self, 'OnLoad', 'XDataClientItens_CuponsGetLoad');
    XDataClientItens_CuponsGet.Left := 64;
    XDataClientItens_CuponsGet.Top := 8;
    XDataClientItens_CuponsDelete.SetParentComponent(Self);
    XDataClientItens_CuponsDelete.Name := 'XDataClientItens_CuponsDelete';
    XDataClientItens_CuponsDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientItens_CuponsDelete, Self, 'OnLoad', 'XDataClientItens_CuponsDeleteLoad');
    SetEvent(XDataClientItens_CuponsDelete, Self, 'OnError', 'XDataClientItens_CuponsDeleteError');
    XDataClientItens_CuponsDelete.Left := 64;
    XDataClientItens_CuponsDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbcupons_id.AfterLoadDFMValues;
    edcupons_id.AfterLoadDFMValues;
    lbproduto_id.AfterLoadDFMValues;
    edproduto_id.AfterLoadDFMValues;
    lbunidade_id.AfterLoadDFMValues;
    edunidade_id.AfterLoadDFMValues;
    lbitem.AfterLoadDFMValues;
    editem.AfterLoadDFMValues;
    lbcfop_cfop.AfterLoadDFMValues;
    edcfop_cfop.AfterLoadDFMValues;
    lbquantidade.AfterLoadDFMValues;
    edquantidade.AfterLoadDFMValues;
    lbproduto_preco.AfterLoadDFMValues;
    edproduto_preco.AfterLoadDFMValues;
    lbmargem_acrescimo.AfterLoadDFMValues;
    edmargem_acrescimo.AfterLoadDFMValues;
    lbvalor_acrescimo.AfterLoadDFMValues;
    edvalor_acrescimo.AfterLoadDFMValues;
    lbmargem_desconto.AfterLoadDFMValues;
    edmargem_desconto.AfterLoadDFMValues;
    lbvalor_desconto.AfterLoadDFMValues;
    edvalor_desconto.AfterLoadDFMValues;
    lbvalor_total.AfterLoadDFMValues;
    edvalor_total.AfterLoadDFMValues;
    lbaliquota_icms.AfterLoadDFMValues;
    edaliquota_icms.AfterLoadDFMValues;
    lbvalor_icms.AfterLoadDFMValues;
    edvalor_icms.AfterLoadDFMValues;
    lbaliquota_icms_red.AfterLoadDFMValues;
    edaliquota_icms_red.AfterLoadDFMValues;
    lbvalor_icms_red.AfterLoadDFMValues;
    edvalor_icms_red.AfterLoadDFMValues;
    lbvalor_base_calculo_icms.AfterLoadDFMValues;
    edvalor_base_calculo_icms.AfterLoadDFMValues;
    lbcst_id.AfterLoadDFMValues;
    edcst_id.AfterLoadDFMValues;
    lbvalor_base_calculo_pis.AfterLoadDFMValues;
    edvalor_base_calculo_pis.AfterLoadDFMValues;
    lbvalor_pis.AfterLoadDFMValues;
    edvalor_pis.AfterLoadDFMValues;
    lbvalor_base_calculo_cofins.AfterLoadDFMValues;
    edvalor_base_calculo_cofins.AfterLoadDFMValues;
    lbvalor_cofins.AfterLoadDFMValues;
    edvalor_cofins.AfterLoadDFMValues;
    lbcsosn_id.AfterLoadDFMValues;
    edcsosn_id.AfterLoadDFMValues;
    lbaliquota_pis.AfterLoadDFMValues;
    edaliquota_pis.AfterLoadDFMValues;
    lbaliquota_cofins.AfterLoadDFMValues;
    edaliquota_cofins.AfterLoadDFMValues;
    lbcst_pis_id.AfterLoadDFMValues;
    edcst_pis_id.AfterLoadDFMValues;
    lbcst_cofins_id.AfterLoadDFMValues;
    edcst_cofins_id.AfterLoadDFMValues;
    lbcodigo_natureza_pis_cofins_id.AfterLoadDFMValues;
    edcodigo_natureza_pis_cofins_id.AfterLoadDFMValues;
    lbaliquota_id.AfterLoadDFMValues;
    edaliquota_id.AfterLoadDFMValues;
    lbproduto_preco_custo.AfterLoadDFMValues;
    edproduto_preco_custo.AfterLoadDFMValues;
    lbcodigo_produto_movimenta_estoque.AfterLoadDFMValues;
    edcodigo_produto_movimenta_estoque.AfterLoadDFMValues;
    lbfuncionario_id.AfterLoadDFMValues;
    edfuncionario_id.AfterLoadDFMValues;
    lbitem_movimenta_estoque.AfterLoadDFMValues;
    editem_movimenta_estoque.AfterLoadDFMValues;
    lbquantidade_embalagem.AfterLoadDFMValues;
    edquantidade_embalagem.AfterLoadDFMValues;
    lbgrade_produto_id.AfterLoadDFMValues;
    edgrade_produto_id.AfterLoadDFMValues;
    lbproduto_nome.AfterLoadDFMValues;
    edproduto_nome.AfterLoadDFMValues;
    lbitem_quantidade_movimenta_estoque.AfterLoadDFMValues;
    editem_quantidade_movimenta_estoque.AfterLoadDFMValues;
    lbscan_promocoes_id.AfterLoadDFMValues;
    edscan_promocoes_id.AfterLoadDFMValues;
    lbvalor_desconto_scanntech.AfterLoadDFMValues;
    edvalor_desconto_scanntech.AfterLoadDFMValues;
    lbvalor_base_calculo_fcp_icms.AfterLoadDFMValues;
    edvalor_base_calculo_fcp_icms.AfterLoadDFMValues;
    lbaliquota_fcp_icms.AfterLoadDFMValues;
    edaliquota_fcp_icms.AfterLoadDFMValues;
    lbvalor_fcp_icms.AfterLoadDFMValues;
    edvalor_fcp_icms.AfterLoadDFMValues;
    lbvalor_base_calculo_fcp_retida.AfterLoadDFMValues;
    edvalor_base_calculo_fcp_retida.AfterLoadDFMValues;
    lbaliquota_fcp_retida.AfterLoadDFMValues;
    edaliquota_fcp_retida.AfterLoadDFMValues;
    lbvalor_fcp_retida.AfterLoadDFMValues;
    edvalor_fcp_retida.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Itens_CuponsDataset.AfterLoadDFMValues;
    Itens_CuponsDatasetid.AfterLoadDFMValues;
    Itens_CuponsDatasetaliado_id.AfterLoadDFMValues;
    Itens_CuponsDatasetdata_base_id.AfterLoadDFMValues;
    Itens_CuponsDatasetcupons_id.AfterLoadDFMValues;
    Itens_CuponsDatasetproduto_id.AfterLoadDFMValues;
    Itens_CuponsDatasetunidade_id.AfterLoadDFMValues;
    Itens_CuponsDatasetitem.AfterLoadDFMValues;
    Itens_CuponsDatasetcfop_cfop.AfterLoadDFMValues;
    Itens_CuponsDatasetquantidade.AfterLoadDFMValues;
    Itens_CuponsDatasetproduto_preco.AfterLoadDFMValues;
    Itens_CuponsDatasetmargem_acrescimo.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_acrescimo.AfterLoadDFMValues;
    Itens_CuponsDatasetmargem_desconto.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_desconto.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_total.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_icms_red.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_icms_red.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetcst_id.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_pis.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_pis.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_cofins.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_cofins.AfterLoadDFMValues;
    Itens_CuponsDatasetcsosn_id.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_pis.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_cofins.AfterLoadDFMValues;
    Itens_CuponsDatasetcst_pis_id.AfterLoadDFMValues;
    Itens_CuponsDatasetcst_cofins_id.AfterLoadDFMValues;
    Itens_CuponsDatasetcodigo_natureza_pis_cofins_id.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_id.AfterLoadDFMValues;
    Itens_CuponsDatasetproduto_preco_custo.AfterLoadDFMValues;
    Itens_CuponsDatasetcodigo_produto_movimenta_estoque.AfterLoadDFMValues;
    Itens_CuponsDatasetfuncionario_id.AfterLoadDFMValues;
    Itens_CuponsDatasetitem_movimenta_estoque.AfterLoadDFMValues;
    Itens_CuponsDatasetquantidade_embalagem.AfterLoadDFMValues;
    Itens_CuponsDatasetgrade_produto_id.AfterLoadDFMValues;
    Itens_CuponsDatasetproduto_nome.AfterLoadDFMValues;
    Itens_CuponsDatasetitem_quantidade_movimenta_estoque.AfterLoadDFMValues;
    Itens_CuponsDatasetscan_promocoes_id.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_desconto_scanntech.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_fcp_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_fcp_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_fcp_icms.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_base_calculo_fcp_retida.AfterLoadDFMValues;
    Itens_CuponsDatasetaliquota_fcp_retida.AfterLoadDFMValues;
    Itens_CuponsDatasetvalor_fcp_retida.AfterLoadDFMValues;
    Itens_CuponsDatasetcodigo_interno.AfterLoadDFMValues;
    Itens_CuponsDatasetexcluido.AfterLoadDFMValues;
    Itens_CuponsDatasetinclusao.AfterLoadDFMValues;
    Itens_CuponsDatasetalteracao.AfterLoadDFMValues;
    Itens_CuponsDatasetexclusao.AfterLoadDFMValues;
    XDataClientItens_CuponsGet.AfterLoadDFMValues;
    XDataClientItens_CuponsDelete.AfterLoadDFMValues;
  end;
end;

end.
